export default {
  "bgb_blessed_box": {
    "en": "Blessed Gift Box\nleft",
    "ja": "祝福されたギフトボックス\n残り",
    "zh": "祝福禮盒\n剩余",
    "zh_cn": "祝福礼盒\n剩余"
  },
  "bgb_blessed_box_toast": {
    "en": "Blessed Gift Box",
    "ja": "祝福されたギフトボックス",
    "zh": "祝福禮盒",
    "zh_cn": "祝福礼盒"
  },
  "bgb_chip_title": {
    "en": "Chip",
    "ja": "チップ",
    "zh": "芯片",
    "zh_cn": "芯片"
  },
  "bgb_claim_button": {
    "en": "Claim",
    "ja": "受け取る",
    "zh": "領取",
    "zh_cn": "领取"
  },
  "bgb_claim_reward": {
    "en": "Claim Reward",
    "ja": "報酬を受け取る",
    "zh": "領取獎勵",
    "zh_cn": "领取奖励"
  },
  "bgb_click_close": {
    "en": " Click to close",
    "ja": "クリックして閉じる",
    "zh": "點擊關閉",
    "zh_cn": "点击关闭"
  },
  "bgb_close_button": {
    "en": "Close",
    "ja": "閉じる",
    "zh": "關閉",
    "zh_cn": "关闭"
  },
  "bgb_confirm_button": {
    "en": "Confirm",
    "ja": "確認",
    "zh": "確認",
    "zh_cn": "确认"
  },
  "bgb_congratulations": {
    "en": "Congratulations",
    "ja": "おめでとう",
    "zh": "恭喜",
    "zh_cn": "恭喜"
  },
  "bgb_empty_record": {
    "en": "No gift records currently",
    "ja": "履歴はありません",
    "zh": "當前沒有禮物記錄",
    "zh_cn": "当前没有礼物记录"
  },
  "bgb_get_box_content": {
    "en": "Everyday tasks will refresh at 0 AM UTC+0",
    "ja": "毎日のタスクは午前 0 時 (UTC+0) に更新されます",
    "zh": "每日任務將在零點（世界標準時間）刷新",
    "zh_cn": "每日任务将在零点（世界标准时间）刷新"
  },
  "bgb_get_box_title": {
    "en": "Get Gift Box",
    "ja": "ギフトボックスを入手",
    "zh": "獲得禮盒",
    "zh_cn": "获得礼盒"
  },
  "bgb_get_method": {
    "en": "Seek and Purify Special Terra\nAble to get Gift Boxes while purifying Special Terra",
    "ja": "特別なTerraを探して浄化する\n特別なTerraの浄化でギフトボックスを獲得可能",
    "zh": "尋找和凈化特殊的Terra\n可以通過凈化特殊的Terra獲得禮盒",
    "zh_cn": "寻找和净化特殊的Terra\n可以通过净化特殊的Terra获得礼盒"
  },
  "bgb_gift_box": {
    "en": "Get Gift Box(everyday task)",
    "ja": "ギフトボックスを入手(毎日のタスク)",
    "zh": "獲取禮盒（每日任務）",
    "zh_cn": "获取礼盒（每日任务）"
  },
  "bgb_gift_records": {
    "en": "Gift Records",
    "ja": "履歴",
    "zh": "禮物記錄",
    "zh_cn": "礼物记录"
  },
  "bgb_insufficient_balance": {
    "en": "Insufficient ARG Balance, unable to redeem.",
    "ja": "ARGが不足しているため交換できません",
    "zh": "ARG不足，無法兌換",
    "zh_cn": "ARG不足，无法兑换"
  },
  "bgb_item_title": {
    "en": "Items",
    "ja": "アイテム",
    "zh": "物品",
    "zh_cn": "物品"
  },
  "bgb_left_today": {
    "en": "Left today:",
    "ja": "今日の残り：",
    "zh": "今日剩余：",
    "zh_cn": "今日剩余："
  },
  "bgb_my_records": {
    "en": "My records",
    "ja": "記録",
    "zh": "我的記錄",
    "zh_cn": "我的记录"
  },
  "bgb_ok_button": {
    "en": "OK",
    "ja": "OK",
    "zh": "確認",
    "zh_cn": "确认"
  },
  "bgb_open_box_batch_button": {
    "en": "Open 5 Boxes",
    "ja": "5箱あける",
    "zh": "開5個",
    "zh_cn": "开5个"
  },
  "bgb_open_box_button": {
    "en": "Open 1 Box",
    "ja": "1箱あける",
    "zh": "開1個",
    "zh_cn": "开1个"
  },
  "bgb_open_box_title": {
    "en": "Open Gift Box",
    "ja": "ギフトボックスを開く",
    "zh": "開禮盒",
    "zh_cn": "开礼盒"
  },
  "bgb_price": {
    "en": "Price:",
    "ja": "価格：",
    "zh": "價格：",
    "zh_cn": "价格："
  },
  "bgb_redeem_box": {
    "en": "Redeem with In-game ARG\n10 Boxes redeemable per day",
    "ja": "In-game ARGで引き換える\n1 日あたり 10 ボックスまで引き換え可能",
    "zh": "用In-game ARG兌換\n每天最多可兌換10個\n",
    "zh_cn": "用In-game ARG兑换\n每天最多可兑换10个\n"
  },
  "bgb_redeem_box_title": {
    "en": "Redeem Gift Box",
    "ja": "ギフトボックスを引き換える",
    "zh": "兌換禮盒",
    "zh_cn": "兑换礼盒"
  },
  "bgb_redeem_button": {
    "en": "Redeem",
    "ja": "引き換える",
    "zh": "兌換",
    "zh_cn": "兑换"
  },
  "bgb_redeem_failure": {
    "en": "Redeem failure!",
    "ja": "引き換えに失敗しました",
    "zh": "兌換失敗！",
    "zh_cn": "兑换失败！"
  },
  "bgb_rule_about": {
    "en": "The oldest tree who has witnessed the whole history in the Garden of Eternity in the Sky lsland, represents the importance of the meaning of Eternity. The place where the Sky Tree has been, known as the pure freeland of Sky lsland, blesses Yulis enduring tasks on the front line, and blesses the souls to pursue eternity with clean spiritual power. It is said that every leaf on the Sky Tree records the memory that happened on the Sky Island.\nHands from the Alliance\nThe constant war in the Yulimeta and the destruction caused by the evil one causing the resources in the universe running low. Fortunately, the alliance that was formed by Yulimeta. Sending the help at the very hour to the Yuli warrior. Rewards from the alliance will be given as gifts to the warrior as they stood their ground to protect the universe",
    "ja": "永遠の楽園で最も古い木であり、歴史全体を見守り、永遠の意味の重要性を表しています。スカイツリーがあった場所は、純粋さと自由の場所、スカイアイランドと呼ばれ、Yuliの最前線での粘り強い働きを祝福し、純粋な霊力で永遠を追求する魂を祝福します。スカイツリーの葉一枚一枚には、スカイアイランドで起きた記憶が刻まれていると言われています。\n同盟からの援助\nYulimetaにおける絶え間ない戦争と悪の勢力による破壊により、宇宙にはほとんど資源が残されていません。幸いなことに、Yulimetaによって形成された同盟は、まさにその時Yuliの戦士たちに援助を送りました。同盟の報酬は、自分の立場を堅持して宇宙を守る戦士に贈り物として与えられます。",
    "zh": "天界永恒花園中最古老的樹，見證了整個歷史，代表著永恒意義的重要性。晴空塔曾經所在的地方，被稱為天空島的純凈自由之地，祝福著Yuli們在前線堅忍不拔的工作，也祝福著靈魂以純凈的精神力量追求永恒。據說，天空之樹上的每一片葉子都記錄著在天空島發生的記憶。\n來自聯盟的援助\nYulimeta中不斷的戰爭和邪惡勢力的破壞導致宇宙中的資源所剩無幾。幸運的是，Yulimeta所組成的聯盟，及時向Yuli戰士發送援助。聯盟的獎勵將作為禮物贈送給堅守陣地保護宇宙的戰士。",
    "zh_cn": "天界永恒花园中最古老的树，见证了整个历史，代表着永恒意义的重要性。晴空塔曾经所在的地方，被称为天空岛的纯净自由之地，祝福着Yuli们在前线坚忍不拔的工作，也祝福着灵魂以纯净的精神力量追求永恒。据说，天空之树上的每一片叶子都记录着在天空岛发生的记忆。\n来自联盟的援助\nYulimeta中不断的战争和邪恶势力的破坏导致宇宙中的资源所剩无几。幸运的是，Yulimeta所组成的联盟，及时向Yuli战士发送援助。联盟的奖励将作为礼物赠送给坚守阵地保护宇宙的战士。"
  },
  "bgb_rules": {
    "en": "Rules",
    "ja": "ルール",
    "zh": "規則",
    "zh_cn": "规则"
  },
  "bgb_rules_sky_tree_title": {
    "en": "About Gratia of Sky Tree",
    "ja": "スカイツリーの贈り物について",
    "zh": "關於天空之樹的饋贈",
    "zh_cn": "关于天空之树的馈赠"
  },
  "bgb_sign_claim": {
    "en": "Daily Sign in Gratia Page\nSign in and get one Gift Box",
    "ja": "イベントページのデイリーサインイン\n毎日のサインインでギフトボックスを受け取ることができます",
    "zh": "活動頁面每日簽到\n每日簽到可領取一個禮盒",
    "zh_cn": "活动页面每日签到\n每日签到可领取一个礼盒"
  },
  "bgb_sky_tree_content": {
    "en": "Open to obtain rich rewards !",
    "ja": "オープンして豪華報酬を獲得しましょう！",
    "zh": "開盒贏好禮！",
    "zh_cn": "开盒赢好礼！"
  },
  "bgb_sky_tree_title": {
    "en": "Gratia of the Sky Tree",
    "ja": "スカイツリーの贈り物",
    "zh": "天空之樹的饋贈",
    "zh_cn": "天空之树的馈赠"
  },
  "bgb_wallet_connect1": {
    "en": "Connect your wallet to claim",
    "ja": "ウォレットを接続して受け取る",
    "zh": "鏈接錢包以領取獎勵",
    "zh_cn": "链接钱包以领取奖励"
  },
  "bgb_wallet_connect2": {
    "en": "Connect your wallet to redeem",
    "ja": "ウォレットに接続して引き換える",
    "zh": "鏈接錢包以兌換",
    "zh_cn": "链接钱包以兑换"
  },
  "channel_card_content": {
    "en": "For every Yuli owner, we offer with 50 partners to view and link with. You may enjoy viewing and chatting with these <%> Yuli partners today.\nIf you wanna view more partners to link with, please come back tomorrow.",
    "ja": "Yuliの所有者ひとり毎に50人のパートナーとリンクし閲覧できます。本日はこの<%>人を閲覧しチャットを楽しむことができます。さらにリンクするパートナーを表示させたい場合は明日もう一度お越しください。",
    "zh": "對於每一位 Yuli 的持有者，我們提供 50 個夥伴供查看和鏈接。今天您可能會喜歡與這 <%> 位 Yuli 夥伴一起觀看和聊天。\n如果您想查看更多合作夥伴進行鏈接，請明天再來。",
    "zh_cn": "对于每一位 Yuli 的持有者，我们提供 50 个伙伴供查看和链接。今天您可能会喜欢与这 <%> 位 Yuli 伙伴一起观看和聊天。\n如果您想查看更多合作伙伴进行链接，请明天再来。"
  },
  "channel_card_title": {
    "en": "No More Partners To View",
    "ja": "表示するパートナーはもういません",
    "zh": "沒有更多可查看的夥伴",
    "zh_cn": "没有更多可查看的伙伴"
  },
  "channel_hell_button": {
    "en": "Say hello",
    "ja": "挨拶する",
    "zh": "打招呼",
    "zh_cn": "打招呼"
  },
  "channel_limit_title": {
    "en": "Unable To Enter Now!",
    "ja": "今は入場できません！",
    "zh": "當前無法進入!",
    "zh_cn": "当前无法进入!"
  },
  "channel_limit_toast": {
    "en": "You need to complete Terra transformation for at least one time, thenyou can start to link with other players.",
    "ja": "他のプレイヤーとのリンクを開始するためには少なくとも1回Terraの変換を完了する必要があります。",
    "zh": "您需要完成至少一次凈化Terra的任務，然後才能開始鏈接其他玩家。",
    "zh_cn": "您需要完成至少一次净化Terra的任务，然后才能开始链接其他玩家。"
  },
  "channel_linking_button_2": {
    "en": "View all",
    "ja": "すべて見る",
    "zh": "查看全部",
    "zh_cn": "查看全部"
  },
  "channel_linking_title_1": {
    "en": "Yuli Partners Linking",
    "ja": "ユリパートナーズリンク",
    "zh": "鏈接Yuli夥伴中",
    "zh_cn": "链接Yuli伙伴中"
  },
  "channel_match": {
    "en": "Matching...",
    "ja": "マッチング中…",
    "zh": "匹配中...",
    "zh_cn": "匹配中.."
  },
  "channel_nearby": {
    "en": "No active players nearby currently",
    "ja": "現在近くにアクティブなプレイヤーはいません",
    "zh": "當前附近沒有活躍玩家",
    "zh_cn": "当前附近没有活跃玩家"
  },
  "channel_quit_button": {
    "en": "Quit",
    "ja": "退出",
    "zh": "退出",
    "zh_cn": "退出"
  },
  "home_Achieve": {
    "en": "Achieve",
    "ja": "達成",
    "zh": "成就",
    "zh_cn": "成就"
  },
  "home_achievement": {
    "en": "ACHIEVEMENT WALL",
    "ja": "アチーブメント",
    "zh": "成就墻",
    "zh_cn": "成就墙"
  },
  "home_add_points_add_points": {
    "en": "Add Points",
    "ja": "ポイントを追加する",
    "zh": "加點",
    "zh_cn": "加点"
  },
  "home_add_points_analysis": {
    "en": "Analysis",
    "ja": "Analysis",
    "zh": "Analysis",
    "zh_cn": "Analysis"
  },
  "home_add_points_available": {
    "en": "Available points:",
    "ja": "利用可能なポイント：",
    "zh": "可分配點數",
    "zh_cn": "可分配点数"
  },
  "home_add_points_awaken": {
    "en": "Awaken",
    "ja": "Awaken",
    "zh": "Awaken",
    "zh_cn": "Awaken"
  },
  "home_add_points_compile": {
    "en": "Compile",
    "ja": "Compile",
    "zh": "Compile",
    "zh_cn": "Compile"
  },
  "home_add_points_meditation": {
    "en": "Meditation",
    "ja": "Meditation",
    "zh": "Meditation",
    "zh_cn": "Meditation"
  },
  "home_add_points_reset": {
    "en": "Reset",
    "ja": "リセット",
    "zh": "重置",
    "zh_cn": "重置"
  },
  "home_add_points_success": {
    "en": "Adding points succeeded.",
    "ja": "ポイント追加に成功しました。",
    "zh": "加點成功。",
    "zh_cn": "加点成功。"
  },
  "home_bag_analysis": {
    "en": "Analysis",
    "ja": "Analysis",
    "zh": "Analysis",
    "zh_cn": "Analysis"
  },
  "home_bag_attribute_reset_card_used_successfully": {
    "en": "Attribute Reset Card used successfully",
    "ja": "属性リセットカードの使用に成功しました",
    "zh": "屬性重置卡使用成功",
    "zh_cn": "属性重置卡使用成功"
  },
  "home_bag_avaiable": {
    "en": "Avaiable",
    "ja": "使用可",
    "zh": "可使用",
    "zh_cn": "可使用"
  },
  "home_bag_awaken": {
    "en": "Awaken",
    "ja": "Awaken",
    "zh": "Awaken",
    "zh_cn": "Awaken"
  },
  "home_bag_basic_enhancement_chip": {
    "en": "Basic material of  <%>  enhancement chips",
    "ja": "<%> 強化チップの基本素材",
    "zh": "<%>增強芯片基礎材料",
    "zh_cn": "<%>增强芯片基础材料"
  },
  "home_bag_box": {
    "en": "Box",
    "ja": "ボックス",
    "zh": "盒子",
    "zh_cn": "盒子"
  },
  "home_bag_box_2": {
    "en": "BOX",
    "ja": "ボックス",
    "zh": "寶盒",
    "zh_cn": "宝盒"
  },
  "home_bag_chance_to_obtain": {
    "en": "Chance to obtain",
    "ja": "入手確率",
    "zh": "獲取幾率",
    "zh_cn": "获取几率"
  },
  "home_bag_chip": {
    "en": "Chip",
    "ja": "チップ",
    "zh": "芯片",
    "zh_cn": "芯片"
  },
  "home_bag_choose_yuli": {
    "en": "Choose Yuli",
    "ja": "Yuliを選択してください",
    "zh": "選擇Yuli",
    "zh_cn": "选择Yuli"
  },
  "home_bag_common": {
    "en": "Common",
    "ja": "Common",
    "zh": "Common",
    "zh_cn": "Common"
  },
  "home_bag_compile": {
    "en": "Compile",
    "ja": "Compile",
    "zh": "Compile",
    "zh_cn": "Compile"
  },
  "home_bag_each_yuli_shield": {
    "en": "Each Yuli can be installed shield once a week",
    "ja": "各Yuliはシールド回復アイテムを週に 1回のみ使用できます",
    "zh": "每只Yuli每周僅可使用1次道具恢復護盾值",
    "zh_cn": "每只Yuli每周仅可使用1次道具恢复护盾值"
  },
  "home_bag_empty_exp": {
    "en": "Sanity EXP is empty, please buy by shop.",
    "ja": "精神力EXPが空なのでショップで購入してください。",
    "zh": "精神力經驗值已空，請通過商店購買。",
    "zh_cn": "精神力经验值已空，请通过商店购买。"
  },
  "home_bag_empty_foodie": {
    "en": "Sanity foodie is empty, please buy by shop.",
    "ja": "精神力のグルメは空です、ショップで購入してください。",
    "zh": "精神力飼料已空，請到商店購買。",
    "zh_cn": "精神力饲料已空，请到商店购买。"
  },
  "home_bag_enhancement_chip": {
    "en": "<%> enhancement chips",
    "ja": "<%> 強化チップ",
    "zh": "<%>增強芯片",
    "zh_cn": "<%>增强芯片"
  },
  "home_bag_epic": {
    "en": "Epic",
    "ja": "Epic",
    "zh": "Epic",
    "zh_cn": "Epic"
  },
  "home_bag_exp_package_used_successfully": {
    "en": "Exp Package used successfully",
    "ja": "Exp パッケージの使用に成功しました",
    "zh": "經驗包使用成功",
    "zh_cn": "经验包使用成功"
  },
  "home_bag_expired_content": {
    "en": "Props below has exceeded the time limit and you can redeem them to Token.",
    "ja": "以下のプロップは制限時間を超えているため、Tokenに引き換えることができます。",
    "zh": "以下道具已超過使用期限，可以兌換成Token。",
    "zh_cn": "以下道具已超过使用期限，可以兑换成Token。"
  },
  "home_bag_expired_title": {
    "en": "Prop Expired",
    "ja": "プロップの有効期限が切れました",
    "zh": "道具已過期",
    "zh_cn": "道具已过期"
  },
  "home_bag_full_yuli_shield_restore": {
    "en": "Full Yuli Shield, unable to restore",
    "ja": "Yuliのシールド値は満タンなので回復する必要はありません",
    "zh": "Yuli護盾值已滿，無需恢復",
    "zh_cn": "Yuli护盾值已满，无需恢复"
  },
  "home_bag_item": {
    "en": "Item",
    "ja": "アイテム",
    "zh": "物品",
    "zh_cn": "物品"
  },
  "home_bag_items": {
    "en": "Items",
    "ja": "アイテム",
    "zh": "物品",
    "zh_cn": "物品"
  },
  "home_bag_legendary": {
    "en": "Legendary",
    "ja": "Legendary",
    "zh": "Legendary",
    "zh_cn": "Legendary"
  },
  "home_bag_maximum_exp": {
    "en": "<%> left to maximum",
    "ja": "残りの<%>ポイントが最大値に達しました",
    "zh": "剩余<%>點達到最大值",
    "zh_cn": "剩余<%>点达到最大值"
  },
  "home_bag_meditation": {
    "en": "Meditation",
    "ja": "Meditation",
    "zh": "Meditation",
    "zh_cn": "Meditation"
  },
  "home_bag_mystery_box": {
    "en": "Mystery Box",
    "ja": "ボックス",
    "zh": "神秘寶盒",
    "zh_cn": "神秘宝盒"
  },
  "home_bag_no_props_in_your_bag": {
    "en": "No props in your bag",
    "ja": "バックパックには何も入っていません",
    "zh": "你的背包裏沒有道具",
    "zh_cn": "你的背包里没有道具"
  },
  "home_bag_no_recover_prop": {
    "en": "No recover prop currently, please purchase in shop.",
    "ja": "現在回復アイテムはありません。ショップで購入してください。",
    "zh": "道具不足，請從商店購買",
    "zh_cn": "道具不足，请从商店购买"
  },
  "home_bag_no_yuli_available": {
    "en": "No Yuli available currently",
    "ja": "現在、適切なYuliはない",
    "zh": "當前沒有合適的Yuli",
    "zh_cn": "当前没有合适的Yuli"
  },
  "home_bag_no_yuli_restored_shield": {
    "en": "No Yuli can be restored by using this Shield",
    "ja": "このアイテムを使用できるYuliはいません",
    "zh": "沒有能使用此道具的Yuli",
    "zh_cn": "没有能使用此道具的Yuli"
  },
  "home_bag_overflow_exp_content_1": {
    "en": "There are <%> points of overflow in EXP supplement this time which won't return, and you cannot continue to instill EXP to this Yuli since it will reach the maximum. Are you sure to continue?",
    "ja": "今回のEXP補充には<%>ポイントのオーバーフローがあります。オーバーフローしたポイントは返還されません。このYuli今日の経験値は上限に達し、これ以上経験値を注入することはできません。続行してもよろしいですか?",
    "zh": "本次EXP補充有<%> 點溢出，溢出點數不會返還，並且此Yuli今日經驗值將達到上限，無法繼續註入經驗值，確定要繼續嗎？",
    "zh_cn": "本次EXP补充有<%> 点溢出，溢出点数不会返还，并且此Yuli今日经验值将达到上限，无法继续注入经验值，确定要继续吗？"
  },
  "home_bag_overflow_exp_content_2": {
    "en": "There are <%> points of overflow in EXP supplement this time which won't return, and you cannot continue to instill EXP to this Yuli since it will reach the upper limit. Are you sure to continue?",
    "ja": "今回のEXP補充には<%>ポイントのオーバーフローがあります。オーバーフローしたポイントは返還されません。このYuliはアップグレードの上限に達してしまい、経験値注入を続けることができなくなります。続行してもよろしいですか?",
    "zh": "本次EXP補充有<%> 點溢出，溢出點數不會返還，並且此Yuli將達到升級上限，無法繼續註入經驗值，確定要繼續嗎？",
    "zh_cn": "本次EXP补充有<%> 点溢出，溢出点数不会返还，并且此Yuli将达到升级上限，无法继续注入经验值，确定要继续吗？"
  },
  "home_bag_overflow_exp_title_1": {
    "en": "Sure to instill?",
    "ja": "確かに注入しますか？",
    "zh": "確定註入？",
    "zh_cn": "确定注入？"
  },
  "home_bag_overflow_exp_title_2": {
    "en": "Sure to Recover?",
    "ja": "本当に回復しますか?",
    "zh": "確定恢復嗎？",
    "zh_cn": "确定恢复吗？"
  },
  "home_bag_poinsts_introduce": {
    "en": "You have added <%> points EScore for your current account, and you can check it in your wallet account later.",
    "ja": "現在のアカウントに <%> ポイントの EScore が追加されました。後でウォレット アカウントで確認できます。",
    "zh": "您當前賬戶已添加<%>分EScore，稍後您可以在錢包賬戶中查看。",
    "zh_cn": "您当前账户已添加<%>分EScore，稍后您可以在钱包账户中查看。"
  },
  "home_bag_prototype": {
    "en": "Prototype",
    "ja": "Prototype",
    "zh": "Prototype",
    "zh_cn": "Prototype"
  },
  "home_bag_redeem": {
    "en": "Redeem",
    "ja": "引き換え",
    "zh": "兌換",
    "zh_cn": "兑换"
  },
  "home_bag_restoring_succeeded": {
    "en": "Restoring succeeded",
    "ja": "回復に成功しました",
    "zh": "恢復成功",
    "zh_cn": "恢复成功"
  },
  "home_bag_sanity": {
    "en": "Sanity",
    "ja": "精神力",
    "zh": "精神力",
    "zh_cn": "精神力"
  },
  "home_bag_shield_introduce": {
    "en": "Sanity Shield is empty, please buy by shop.",
    "ja": "精神力シールドは空です。ショップで購入してください。",
    "zh": "精神力護盾已空，請到商店購買。",
    "zh_cn": "精神力护盾已空，请到商店购买。"
  },
  "home_bag_superior": {
    "en": "Superior",
    "ja": "Superior",
    "zh": "Superior",
    "zh_cn": "Superior"
  },
  "home_bag_tamasii": {
    "en": "Tamasii",
    "ja": "タマシイ",
    "zh": "靈珠",
    "zh_cn": "灵珠"
  },
  "home_bag_tamasii_introduce": {
    "en": "Yuli Tamasii is the product of Yuli Breed, which can be converted to Mystery Box after purifying.",
    "ja": "Yuli TamasiiはYuli ブリードの産物で、浄化後にミステリーボックスに変換できます。",
    "zh": "Yuli靈珠是Yuli繁育的產物，提純後可以轉化為神秘盒子。",
    "zh_cn": "Yuli灵珠是Yuli繁育的产物，提纯后可以转化为神秘盒子。"
  },
  "home_bag_time_days": {
    "en": "Days",
    "ja": "日",
    "zh": "天",
    "zh_cn": "天"
  },
  "home_bag_time_hours": {
    "en": "Hours",
    "ja": "時間",
    "zh": "小時",
    "zh_cn": "小时"
  },
  "home_bag_time_mins": {
    "en": "Mins",
    "ja": "分",
    "zh": "分鐘",
    "zh_cn": "分钟"
  },
  "home_bag_time_second": {
    "en": "Seconds",
    "ja": "秒",
    "zh": "秒",
    "zh_cn": "秒"
  },
  "home_bag_today_limit": {
    "en": "Today's Limit",
    "ja": "本日の上限",
    "zh": "今日上限",
    "zh_cn": "今日上限"
  },
  "home_bag_uncommon": {
    "en": "Uncommon",
    "ja": "アンコモン",
    "zh": "罕見",
    "zh_cn": "罕见"
  },
  "home_bag_use": {
    "en": "use",
    "ja": "使う",
    "zh": "使用",
    "zh_cn": "使用"
  },
  "home_bag_yuli_in_cooling_period": {
    "en": "Yuli in Cooling Period, unable to restore",
    "ja": "Yuliはクールタイム中のため回復できません",
    "zh": "Yuli在冷卻期中，無法恢復",
    "zh_cn": "Yuli在冷却期中，无法恢复"
  },
  "home_beginner_newline_tasks": {
    "en": "Beginner\nTasks",
    "ja": "ビギナー\nタスク",
    "zh": "新手\n任務",
    "zh_cn": "新手\n任务"
  },
  "home_beginner_tasks": {
    "en": "BeginnerTasks",
    "ja": "ビギナータスク",
    "zh": "新手任務",
    "zh_cn": "新手任务"
  },
  "home_bgb_box": {
    "en": "Gratia of the Sky Tree",
    "ja": "スカイツリーのグラティア",
    "zh": "天空之樹的饋贈",
    "zh_cn": "天空之树的馈赠"
  },
  "home_breed_breed": {
    "en": "Breed",
    "ja": "ブリード",
    "zh": "繁育",
    "zh_cn": "繁育"
  },
  "home_breed_breed_count": {
    "en": "Breed count",
    "ja": "ブリード回数",
    "zh": "繁育次數",
    "zh_cn": "繁育次数"
  },
  "home_breed_choose_yuli": {
    "en": "Choose Yuli",
    "ja": "Yuliを選択してください",
    "zh": "選擇Yuli",
    "zh_cn": "选择Yuli"
  },
  "home_breed_confirm": {
    "en": "Confirm",
    "ja": "確認",
    "zh": "確認",
    "zh_cn": "确认"
  },
  "home_breed_consumption": {
    "en": "Breed Consumption",
    "ja": "消費ブリードアイテム",
    "zh": "繁育消耗",
    "zh_cn": "繁育消耗"
  },
  "home_breed_content": {
    "en": "Yuli has a variety of cultivation systems.Upgrading yuli can improve Yuli'sability and unlock chip parts, thereby\nncreasing income.When you have two Yulis above level 30 withcommon quality and above, you can get Yulithrough breeding .",
    "ja": "Yuliには様々な育成システムがあり、Yuliをアップグレードすることで能力が向上したり、チップパーツがアンロックされたりします。\nコモン以上のレアリティかつレベル30以上のYuliを2体所持している場合、ブリードによりYuliを入手できます。",
    "zh": "Yuli有完善的養成系統，升級Yuli可以提高Yul的能力，解鎖芯片部件，從而\n增加收入。當你擁有兩只30級以上且品質普通及以上的Yul時，即可通過繁育获得新的Yuli。",
    "zh_cn": "Yuli有完善的养成系统，升级Yuli可以提高Yul的能力，解锁芯片部件，从而\n增加收入。当你拥有两只30级以上且品质普通及以上的Yul时，即可通过繁育获得新的Yuli。"
  },
  "home_breed_content_1": {
    "en": "You need use Yuli Foodie to recover Yuli's Stamina first,or you can't use it to breed.",
    "ja": "Yuliの精神力を回復するには、アイテムを使用する必要があります。そうしないとブリードさせることができません。",
    "zh": "你需要先餵食Yuli來恢復Yuli的精神力，否則你無法讓它繁育。",
    "zh_cn": "你需要先喂食Yuli来恢复Yuli的精神力，否则你无法让它繁育。"
  },
  "home_breed_content_3": {
    "en": "Congrats!\nYou get a Yuli Tamasii",
    "ja": "おめでとう！\nYuliタマシイを手に入れました",
    "zh": "恭喜！\n您得到了一個Yuli 靈珠！",
    "zh_cn": "恭喜！\n您得到了一个Yuli 灵珠！"
  },
  "home_breed_content_4": {
    "en": "Yuli Tamasii can be converted to MysteryBox, and you can view it in Wallet Collection",
    "ja": "Yuliタマシイはミステリーボックスに変換でき、ウォレットのコレクションから確認できます",
    "zh": "Yuli 靈珠可以轉換為神秘盒子，您可以在錢包收藏中查看",
    "zh_cn": "Yuli 灵珠可以转换为神秘盒子，您可以在钱包收藏中查看"
  },
  "home_breed_content_5": {
    "en": "Opps!...No Yuli To Match",
    "ja": "しまった!...一致するYuliはいない",
    "zh": "哎呀！沒有匹配的Yuli",
    "zh_cn": "哎呀！没有匹配的Yuli"
  },
  "home_breed_content_6": {
    "en": "You don't have another available Yuli to match and breed.",
    "ja": "マッチングして交配できる別のYuliがいません。",
    "zh": "您沒有其他合適的Yuli能匹配繁育。",
    "zh_cn": "您没有其他合适的Yuli能匹配繁育。"
  },
  "home_breed_content_7": {
    "en": "Insufficient Breed Tickets, unable to breed now.",
    "ja": "ブリードチケットが不足しているため、現在ブリードできません。",
    "zh": "繁育券不足，無法繁育",
    "zh_cn": "繁育券不足，无法繁育"
  },
  "home_breed_content_8": {
    "en": "Insufficient ARG Balance, unable to breed.",
    "ja": "ARGバランスが不十分なため、繁殖できません",
    "zh": "ARG余额不足，無法繁育。",
    "zh_cn": "ARG余额不足，无法繁育。"
  },
  "home_breed_match_yuli": {
    "en": "Match Yuli",
    "ja": "Yuliを組み合わせる",
    "zh": "匹配Yuli",
    "zh_cn": "匹配Yuli"
  },
  "home_breed_opps": {
    "en": "Opps!....",
    "ja": "おっと！",
    "zh": "哎呀！",
    "zh_cn": "哎呀！"
  },
  "home_breed_quit": {
    "en": "Quit",
    "ja": "退出",
    "zh": "退出",
    "zh_cn": "退出"
  },
  "home_breed_sanity": {
    "en": "Sanity",
    "ja": "精神力",
    "zh": "精神力",
    "zh_cn": "精神力"
  },
  "home_breed_sanity_title": {
    "en": "Yuli's Sanity ls Not Full",
    "ja": "Yuliの精神力が全快ではありません",
    "zh": "Yuli的精神力不足",
    "zh_cn": "Yuli的精神力不足"
  },
  "home_breed_success": {
    "en": "Breed Success.",
    "ja": "ブリードしました。",
    "zh": "繁育成功",
    "zh_cn": "繁育成功"
  },
  "home_breed_title": {
    "en": "Cultivation of Yuli",
    "ja": "Yuliの育成",
    "zh": "Yuli的養成",
    "zh_cn": "Yuli的养成"
  },
  "home_breed_unable_level": {
    "en": "Unable To Breed Now",
    "ja": "現在ブリードできません",
    "zh": "當前無法繁育",
    "zh_cn": "当前无法繁育"
  },
  "home_breed_unable_level_content": {
    "en": "It's required that Yuli cannot breed unless achieving Lv.30, your Yuli don't satisfy the requirement temporarily.",
    "ja": "Yuliをブリードするにはレベル 30 に達する必要がありますが、あなたのYuliは現時点では要件を満たしていません。",
    "zh": "Yuli必須達到30級才能繁育，您的Yuli暫時不滿足要求。",
    "zh_cn": "Yuli必须达到30级才能繁育，您的Yuli暂时不满足要求。"
  },
  "home_breed_yuli_breed": {
    "en": "Yuli Breed",
    "ja": "Yuliブリード",
    "zh": "Yuli繁育",
    "zh_cn": "Yuli繁育"
  },
  "home_cancel_button": {
    "en": "Cancel",
    "ja": "キャンセル",
    "zh": "取消",
    "zh_cn": "取消"
  },
  "home_channel": {
    "en": "Channel",
    "ja": "チャンネル",
    "zh": "頻道",
    "zh_cn": "频道"
  },
  "home_chat": {
    "en": "Chat",
    "ja": "チャット",
    "zh": "聊天",
    "zh_cn": "聊天"
  },
  "home_coa": {
    "en": "COA",
    "ja": "カード",
    "zh": "卡牌",
    "zh_cn": "卡牌"
  },
  "home_confirm_button": {
    "en": "Confirm",
    "ja": "確認",
    "zh": "確認",
    "zh_cn": "确认"
  },
  "home_congrats_content_1": {
    "en": "Congrats! You have completed the tasks! You can explore other functions by yourself and increase your income through various methods.\nHope you enjoy yourself in Yulimeta!",
    "ja": "おめでとうございます！タスクは完了しました!他の機能も自分で探索し、さまざまな方法で収入を増やすことができます。\nYulimetaを楽しんでください。",
    "zh": "恭喜！你已經完成任務了！其他功能你可以自己探索，通過各種方式增加你的收入。\n希望你在Yulimeta玩得開心！",
    "zh_cn": "恭喜！你已经完成任务了！其他功能你可以自己探索，通过各种方式增加你的收入。\n希望你在Yulimeta玩得开心！"
  },
  "home_content": {
    "en": "Yulis are vour most loval partners in this world.They have powerful skills and abilities, and they will fight side by side with you in this world.",
    "ja": "Yuliはこの世界で最も忠実なあなたのパートナーです。彼らは強力なスキルと能力を持っており、この世界であなたと一緒に戦ってくれます。",
    "zh": "Yuli是你在這個世界上最忠誠的夥伴，他們擁有強大的技能和能力，他們將在這個世界裏與你並肩作戰。",
    "zh_cn": "Yuli是你在这个世界上最忠诚的伙伴，他们拥有强大的技能和能力，他们将在这个世界里与你并肩作战。"
  },
  "home_ele_content": {
    "en": "Yuli has five elements: ice, fire, thunder, rockand wind. lt is recommended that you gettogether five elements to get the resistancebuff, which will help you get higher benefits.",
    "ja": "Yuliには氷、火、雷、岩、風の5つの要素があり、5つの要素を揃えて耐性バフを獲得すると、より高い効果が得られるのでおすすめです。",
    "zh": "Yuli有五種元素：冰、火、雷、巖石和風。建議你湊齊五元素來獲得抗性buff，這樣可以幫助你獲得更高的收益。",
    "zh_cn": "Yuli有五种元素：冰、火、雷、岩石和风。建议你凑齐五元素来获得抗性buff，这样可以帮助你获得更高的收益。"
  },
  "home_ele_title": {
    "en": "Elements of Yuli",
    "ja": "Yuliの要素",
    "zh": "Yuli的元素",
    "zh_cn": "Yuli的元素"
  },
  "home_gacha": {
    "en": "Gacha",
    "ja": "ガチャ",
    "zh": "卡池",
    "zh_cn": "卡池"
  },
  "home_gain": {
    "en": "Gain",
    "ja": "バフ",
    "zh": "增益",
    "zh_cn": "增益"
  },
  "home_gameplay_content": {
    "en": "Yuli can purify the Terra in the area byconsuming shields and sanity, and can obtainrelated resources (ARG, EXP cards, Lost Pageevent-limited props).When Yuli reaches lv.50.you can also get ART through purification",
    "ja": "Yuliはシールドと精神力を消費することでTerraを浄化し、関連リソース（ARG、経験値カード、ロストページ、イベント限定アイテム）を獲得することができます。ユリがLv.50になると浄化でARTも獲得可能です。",
    "zh": "Yuli可以通過消耗護盾和精神力來凈化Terra，並可以獲得相關資源（ARG、經驗卡、失落頁事件限定道具）。當Yuli達到lv.50時，還可以通過凈化獲得ART",
    "zh_cn": "Yuli可以通过消耗护盾和精神力来净化Terra，并可以获得相关资源（ARG、经验卡、失落页事件限定道具）。当Yuli达到lv.50时，还可以通过净化获得ART"
  },
  "home_gameplay_title": {
    "en": "Abilities of Yuli",
    "ja": "Yuliの能力",
    "zh": "Yuli的能力",
    "zh_cn": "Yuli的能力"
  },
  "home_guide": {
    "en": "Guide",
    "ja": "ガイド",
    "zh": "向導",
    "zh_cn": "向导"
  },
  "home_home_stardust": {
    "en": "Stardust",
    "ja": "スターダスト",
    "zh": "星塵",
    "zh_cn": "星尘"
  },
  "home_illegal_use_simulator": {
    "en": "System has detected illegal use of simulator, resulting in inability to play. Please unintall and try again later.",
    "ja": "システムがシミュレータの違法な使用を検出したため、プレイできなくなりました。アンインストールして、後でもう一度試してください。",
    "zh": "系統檢測到非法使用模擬器，導致無法進行遊戲。請卸載並稍後重試。",
    "zh_cn": "系统检测到非法使用模拟器，导致无法进行游戏。请卸载并稍后重试。"
  },
  "home_lab": {
    "en": "Lab",
    "ja": "ラブ",
    "zh": "合成臺",
    "zh_cn": "合成台"
  },
  "home_level_arg_error_title": {
    "en": "Opps!....",
    "ja": "おっと！",
    "zh": "哎呀！",
    "zh_cn": "哎呀！"
  },
  "home_level_error_content_1": {
    "en": "Insufficient ARG Balance, unable to Level up.",
    "ja": "ARG残高が不足しているため、レベルアップできません。",
    "zh": "ARG余額不足，無法升級",
    "zh_cn": "ARG余额不足，无法升级"
  },
  "home_level_error_content_2": {
    "en": "Insufficient Balance, unable to Level up",
    "ja": "残高が不足しているため、レベルアップできません。",
    "zh": "余額不足，無法升級",
    "zh_cn": "余额不足，无法升级"
  },
  "home_level_error_content_3": {
    "en": "Insufficient Terra Prism  unable to level up now ",
    "ja": "Terra Prismが不足しているため、レベルアップできません。",
    "zh": "Terra Prism不足，無法升級",
    "zh_cn": "Terra Prism不足，无法升级"
  },
  "home_level_level_up": {
    "en": "Level Up",
    "ja": "レベルアップ",
    "zh": "升級",
    "zh_cn": "升级"
  },
  "home_level_level_up_botton": {
    "en": "Level up",
    "ja": "レベルアップ",
    "zh": "升級",
    "zh_cn": "升级"
  },
  "home_level_toast_level_up": {
    "en": "Yuli Level up!",
    "ja": "Yuliのレベルアップ！",
    "zh": "Yuli升級成功！",
    "zh_cn": "Yuli升级成功！"
  },
  "home_loading_poor_network": {
    "en": "Poor network connection currently, please try again later.",
    "ja": "ネットワーク接続が不安定です。後でもう一度お試しください。",
    "zh": "當前網絡狀況不佳，請稍後重試。",
    "zh_cn": "当前网络状况不佳，请稍后重试。"
  },
  "home_loading_tips": {
    "en": "Always be aware of your surroundings\nDo not use while cycling or driving",
    "ja": "常に周囲に注意してください。\n自転車や運転中には使用しないでください。",
    "zh": "時刻註意周圍的環境\n不要在騎行或開車時玩遊戲",
    "zh_cn": "时刻注意周围的环境\n不要在骑行或开车时玩游戏"
  },
  "home_login_link": {
    "en": "If you want to experience full functionality, please log in.",
    "ja": "すべての機能を体験したい場合は、ログインしてください。",
    "zh": "如果想要體驗完整功能，請登錄",
    "zh_cn": "如果想要体验完整功能，请登录"
  },
  "home_login_now": {
    "en": "Login Now",
    "ja": "ここからログイン",
    "zh": "立即登錄",
    "zh_cn": "立即登录"
  },
  "home_main_network_error": {
    "en": "Network error",
    "ja": "ネットワークエラー",
    "zh": "網絡錯誤",
    "zh_cn": "网络错误"
  },
  "home_main_network_resumed": {
    "en": "Network resumed",
    "ja": "ネットワーク回復",
    "zh": "網絡恢復",
    "zh_cn": "网络恢复"
  },
  "home_main_quit_the_application": {
    "en": "Press again to quit the application",
    "ja": "もう一度クリックしてアプリを終了します",
    "zh": "再次點擊退出應用",
    "zh_cn": "再次点击退出应用"
  },
  "home_map_account_blocked_content": {
    "en": "Your account had abnormal behavior of purifying Terra and has been banned temporarily, it will be lifted after the end of the countdown. \nIf you have questions please contact with us.",
    "ja": "あなたのアカウントはTerraを浄化する際に異常な行為があったため一時的に停止されましたが、カウントダウン終了後に解除されます。 \nご質問がございましたら、お問い合わせください。",
    "zh": "您的賬號存在凈化Terra的異常行為，已被暫時封禁，倒計時結束後將解除。 \n如有疑問請聯系我們。",
    "zh_cn": "您的账号存在净化Terra的异常行为，已被暂时封禁，倒计时结束后将解除。 \n如有疑问请联系我们。"
  },
  "home_map_account_blocked_title": {
    "en": "Account Blocked",
    "ja": "アカウントが凍結されました",
    "zh": "帳戶被凍結",
    "zh_cn": "帐户被冻结"
  },
  "home_map_airdrop_dialog_title": {
    "en": "What a pity! lt has been claimed by others.",
    "ja": "残念ながら！他の人に拾われました。",
    "zh": "很遺憾！已被其他人領取。",
    "zh_cn": "很遗憾！已被其他人领取。"
  },
  "home_map_base_buff_dialog_chips_buffs": {
    "en": "Chips buffs",
    "ja": "チップバフ",
    "zh": "芯片增益",
    "zh_cn": "芯片增益"
  },
  "home_map_base_buff_dialog_msg": {
    "en": "Increase purification income by increasing Yuli level or equipping chips",
    "ja": "Yuliのレベルを上げるかチップを装備することで浄化効果が増加します",
    "zh": "通過提升Yuli等級或裝備芯片來增加凈化收益",
    "zh_cn": "通过提升Yuli等级或装备芯片来增加净化收益"
  },
  "home_map_base_buffs_analysis": {
    "en": "Analysis",
    "ja": "Analysis",
    "zh": "Analysis",
    "zh_cn": "Analysis"
  },
  "home_map_base_buffs_compiling": {
    "en": "Compiling",
    "ja": "Compiling",
    "zh": "Compiling",
    "zh_cn": "Compiling"
  },
  "home_map_base_buffs_dialog_attributes_buffs": {
    "en": "Attributes buffs",
    "ja": "属性バフ",
    "zh": "屬性增益",
    "zh_cn": "属性增益"
  },
  "home_map_base_buffs_dialog_environment": {
    "en": "Environment -10%",
    "ja": "環境：-10%",
    "zh": "環境：-10%",
    "zh_cn": "环境：-10%"
  },
  "home_map_base_buffs_dialog_title": {
    "en": "Yuli's Base Buffs",
    "ja": "Yuliの基本バフ",
    "zh": "Yuli的基礎增益",
    "zh_cn": "Yuli的基础增益"
  },
  "home_map_buff_dialog_content": {
    "en": "Yulis enjoy the environment of elements balance. When your team contains Yulis of five elements (Ice, Fire, Rock, Thunder and Wind), the Yulis will act more efficiently, and the efficiency of Terra purification will increase by 10%.",
    "ja": "Yuliは要素のバランスが取れた環境を好みます。五大属性（氷、火、岩、雷、風）のYuliをチームに入れると、ユリの行動が効率化し、Terraの浄化効率が10％アップします。",
    "zh": "Yuli喜歡元素平衡的環境。當你的隊伍中包含五種元素（冰、火、巖石、雷、風）的Yuli時，Yuli的行動會更加高效，凈化Terra的收益會提高10%。",
    "zh_cn": "Yuli喜欢元素平衡的环境。当你的队伍中包含五种元素（冰、火、岩石、雷、风）的Yuli时，Yuli的行动会更加高效，净化Terra的收益会提高10%。"
  },
  "home_map_buff_dialog_team_buff": {
    "en": "Team Buff ",
    "ja": "チームバフ",
    "zh": "團隊增益",
    "zh_cn": "团队增益"
  },
  "home_map_buff_dialog_title": {
    "en": "The Elements Buff",
    "ja": "エレメントバフ",
    "zh": "元素增益",
    "zh_cn": "元素增益"
  },
  "home_map_character_infos_dialog_title": {
    "en": "Guide Infos",
    "ja": "Guide情報",
    "zh": "向導信息",
    "zh_cn": "向导信息"
  },
  "home_map_click_total_claimed": {
    "en": "Total Claimed: ",
    "ja": "合計クリック数:",
    "zh": "總點擊數：",
    "zh_cn": "总点击数："
  },
  "home_map_day_refresh": {
    "en": "Refresh at 20:00 UTC+0 every day",
    "ja": "毎日 20:00 UTC+0 に更新します",
    "zh": "每天 20:00 UTC+0 刷新",
    "zh_cn": "每天 20:00 UTC+0 刷新"
  },
  "home_map_dialog_go_install": {
    "en": "Go Install",
    "ja": "許可する",
    "zh": "去授權",
    "zh_cn": "去授权"
  },
  "home_map_dialog_go_to_connect": {
    "en": "Go to connect",
    "ja": "接続する",
    "zh": "去連接",
    "zh_cn": "去连接"
  },
  "home_map_dialog_reject_location_content": {
    "en": "You cannot enjoy the LBS Game of Yulimeta unless your location information be authorized.",
    "ja": "位置情報が許可されないとLBS Game of Yulimetaを楽しむことができません。",
    "zh": "您未授權位置權限，無法享受Yulimeta的LBS玩法。\n",
    "zh_cn": "您未授权位置权限，无法享受Yulimeta的LBS玩法。"
  },
  "home_map_dialog_use_your_location_content": {
    "en": "To see maps for automatically tracked activities, allow Yulimeta to use your location when the app is in use.\nYulimeta collects location data to enable identification of nearby Terra Signals and Floating Lights when the app is in use.",
    "ja": "アプリの使用中にアクティビティマップを自動表示するには、 Yulimeta に位置情報の使用を許可してください。\nYulimeta は、近くの Terra 信号点と浮光点を認識するために位置データを収集します。",
    "zh": "請允許 Yulimeta 在使用過程中使用您的位置權限，用於查看地圖和自動跟蹤活動。\nYulimeta 會收集位置數據，以便在遊戲中識別您附近的 Terra 信號點 和浮光點。",
    "zh_cn": "请允许 Yulimeta 在使用过程中使用您的位置权限，用于查看地图和自动跟踪活动。\nYulimeta 会收集位置数据，以便在游戏中识别您附近的 Terra 信号点 和浮光点。"
  },
  "home_map_dialog_use_your_location_title": {
    "en": "Use Your Location",
    "ja": "位置情報の使用を許可する",
    "zh": "使用您的位置權限",
    "zh_cn": "使用您的位置权限"
  },
  "home_map_every_day": {
    "en": "8PM UTC+0 Every day",
    "ja": "毎日午後 8 時 (UTC+0)",
    "zh": "每天晚上 8 點（UTC+0）",
    "zh_cn": "每天晚上 8 点（UTC+0）"
  },
  "home_map_fixed_received_today": {
    "en": "Unable To Claim Today, Refresh At",
    "ja": "取得できません。次の更新時間は",
    "zh": "今日無法獲取，刷新时间是",
    "zh_cn": "今日无法获取，刷新时间是"
  },
  "home_map_fixed_received_wait": {
    "en": "Unable To Claim Now, Please Wait",
    "ja": "取得できません。カウン\nトダウン終了後に更新します。",
    "zh": "現在無法獲取，請等待",
    "zh_cn": "现在无法获取，请等待"
  },
  "home_map_fixed_unaccalimed": {
    "en": "Here Are Your Rewards For Today",
    "ja": "今日の報酬はこちらです",
    "zh": "這是你今天的獎勵",
    "zh_cn": "这是你今天的奖励"
  },
  "home_map_go_install": {
    "en": "Go install",
    "ja": "許可する",
    "zh": "去授權",
    "zh_cn": "去授权"
  },
  "home_map_guide_content1": {
    "en": "Yulimeta is a LBS based game, so you need seek treasure points on map and collect them! There are several kinds of points around you, and I will introduce one by one",
    "ja": "Yulimeta は LBS ベースのゲームなので、マップ上にあるお宝スポットを見つけて収集する必要があります。あなたの周りにもお宝スポットがたくさんあるので、一つずつ紹介していきます。",
    "zh": "Yulimeta是一款基於LBS的遊戲，所以你需要在地圖上尋找寶藏點並收集它們！在你身邊有很多種寶藏點，我一一介紹",
    "zh_cn": "Yulimeta是一款基于LBS的游戏，所以你需要在地图上寻找宝藏点并收集它们！在你身边有很多种宝藏点，我一一介绍"
  },
  "home_map_guide_content2": {
    "en": "Stardust Point is the reaction of Terra signs. When you are near it,  it will turn into active, which means you can click to obtain it! It will give you Stardust energies!",
    "ja": "スターダストポイントはTerra信号のサインで、近づくとアクティブになり、クリックすると取得できます！スターダストエネルギーを与えます！",
    "zh": "星塵點是Terra信號的標誌，當你靠近它時，它會變成活躍狀態，此時你可以點擊獲取它！它會給你星塵能量！",
    "zh_cn": "星尘点是Terra信号的标志，当你靠近它时，它会变成活跃状态，此时你可以点击获取它！它会给你星尘能量！"
  },
  "home_map_guide_content3": {
    "en": "Floating Light is the reaction of Terra signs. When you are near it, it will turn into active, which means you can click to obtain it! It will give you Yuli EXP!",
    "ja": "浮いている光の玉は Terra 信号のサインです。近づくとアクティブになり、クリックして取得できます。Yuli EXPがもらえます！",
    "zh": "浮光點是Terra信號的標誌，當你靠近它時，它會變成活躍狀態，此時你可以點擊獲取它！它會給你Yuli EXP！",
    "zh_cn": "浮光点是Terra信号的标志，当你靠近它时，它会变成活跃状态，此时你可以点击获取它！它会给你Yuli EXP！"
  },
  "home_map_guide_content4": {
    "en": "Terra is the reaction of chaos energy. When you are near it, it will turn into active, which means you can click to purify it! You may obtain rich treasures after purifying!",
    "ja": "Terraは混沌としたエネルギーの象徴です。c近づくとアクティブになり、クリックして取得できます。浄化後は豪華なお宝が手に入るかも！",
    "zh": "Terra是混沌能量的標誌。當你靠近它時，它會變成活動狀態，此時你可以點擊獲取它！凈化後可能會獲得豐富的寶物！",
    "zh_cn": "Terra是混沌能量的标志。当你靠近它时，它会变成活动状态，此时你可以点击获取它！净化后可能会获得丰富的宝物！"
  },
  "home_map_guide_content5": {
    "en": "You may meet with all these three points on map wherever you move, and you are able to click them when you move nearby. So let's go to have a try!",
    "ja": "どこに行っても、地図上でこれら 3 つのお宝スポットに遭遇する可能性があり、近くに移動するとクリックできます。さあ、試しに行ってみましょう！",
    "zh": "無論您走到哪裏，您都可能會在地圖上遇到這三種寶藏點，並且當您移動到寶藏點附近時，您可以單擊它們。現在我們就去嘗試一下吧！",
    "zh_cn": "无论您走到哪里，您都可能会在地图上遇到这三种宝藏点，并且当您移动到宝藏点附近时，您可以单击它们。现在我们就去尝试一下吧！"
  },
  "home_map_guide_title1": {
    "en": "Map",
    "ja": "マップ",
    "zh": "地圖",
    "zh_cn": "地图"
  },
  "home_map_guide_title2": {
    "en": "Map·Stardust Point",
    "ja": "マップ・スターダストポイント",
    "zh": "地圖·星塵點",
    "zh_cn": "地图·星尘点"
  },
  "home_map_guide_title3": {
    "en": "Map·Floating Light",
    "ja": "マップ・浮かぶ光",
    "zh": "地圖·浮光點",
    "zh_cn": "地图·浮光点"
  },
  "home_map_guide_title4": {
    "en": "Map·Terra",
    "ja": "マップ・Terra",
    "zh": "地圖·Terra",
    "zh_cn": "地图·Terra"
  },
  "home_map_guide_title5": {
    "en": "Map·All",
    "ja": "地図・すべて",
    "zh": "地圖·總述",
    "zh_cn": "地图·总述"
  },
  "home_map_guide_toast": {
    "en": "Since we have acknowledged Infos of Terra, let's move out and start our journey immediately! Remember you need to collect Stardust and purify Terras!",
    "ja": "Terraの基本情報を理解したところで、早速旅に出てみましょう！スターダストを集めてTerraを浄化する必要があることを忘れないでください。",
    "zh": "現在我們已經了解了Terra的基本信息了，那我們就立刻出發，開始我們的旅程吧！請記住，您需要收集星塵並凈化Terra！",
    "zh_cn": "现在我们已经了解了Terra的基本信息了，那我们就立刻出发，开始我们的旅程吧！请记住，您需要收集星尘并净化Terra！"
  },
  "home_map_linking_button": {
    "en": "Start linking",
    "ja": "リンクを開始する",
    "zh": "開始鏈接",
    "zh_cn": "开始链接"
  },
  "home_map_linking_button_1": {
    "en": "View all",
    "ja": "すべて見る",
    "zh": "查看全部",
    "zh_cn": "查看全部"
  },
  "home_map_linking_title": {
    "en": "Yuli Link Channel now available...",
    "ja": "Yuliリンクチャンネルが利用可能になりました...",
    "zh": "Yuli鏈接頻道已啟用",
    "zh_cn": "Yuli链接频道已启用"
  },
  "home_map_linking_title_1": {
    "en": "Yuli Partners Linking",
    "ja": "Yuliパートナーズリンク",
    "zh": "鏈接Yuli夥伴中",
    "zh_cn": "链接Yuli伙伴中"
  },
  "home_map_no_leader": {
    "en": "You can't collect Stardust without guide",
    "ja": "スターダストはGuideなしでは集められません",
    "zh": "沒有向導您無法收集星塵",
    "zh_cn": "没有向导您无法收集星尘"
  },
  "home_map_open_light_is_nothing": {
    "en": "Unfortunately, there is nothing",
    "ja": "残念ながら何もありません",
    "zh": "很遺憾，這裏什麽都沒有",
    "zh_cn": "很遗憾，这里什么都没有"
  },
  "home_map_permisson_fitness_authorized": {
    "en": "We cannot fetch your step data and give your relevant awards unless your fitness information be authorized.",
    "ja": "運動データの使用許可がなければ、歩数データを取得し、それに応じた報酬を与えることはできません。\n",
    "zh": "您未授權健身運動權限，我們無法獲取您的步數數據並給予您相應獎勵。",
    "zh_cn": "您未授权健身运动权限，我们无法获取您的步数数据并给予您相应奖励。"
  },
  "home_map_permisson_health_content": {
    "en": "To count your steps record, allow Yulimeta to use your Health Connect when the app is in use.\nYulimeta collects steps data to count your steps and give out game rewards when the app is in use.",
    "ja": "Yulimetaが使用中の歩数をカウントするためにデータ連携を許可してください。\nYulimetaは歩数データを収集し、対応するゲーム報酬を提供します。",
    "zh": "請允許Yulimeta在使用過程中使用您的健身運動權限，用於計算您的步數。\nYulimeta會收集步數數據，並發放相應的遊戲獎勵。",
    "zh_cn": "请允许Yulimeta在使用过程中使用您的健身运动权限，用于计算您的步数。\nYulimeta会收集步数数据，并发放相应的游戏奖励。"
  },
  "home_map_permisson_health_title": {
    "en": "Use Your Health Connect",
    "ja": "運動データ使用を許可する",
    "zh": "使用您的健身運動權限",
    "zh_cn": "使用您的健身运动权限"
  },
  "home_map_photo_authorized": {
    "en": "You cannot enjoy the Photo Library of Yulimeta unless your photo information be authorized.",
    "ja": "写真情報の使用が許可されていないため、Yulimetaのフォトライブラリを使用することはできません",
    "zh": "您未授權相冊權限，無法使用Yulimeta的相冊庫。",
    "zh_cn": "您未授权相册权限，无法使用Yulimeta的相册库。"
  },
  "home_map_pray_introduce_content_1": {
    "en": "If you have Yuli NFT in your wallet account, you may need to pray once a day, which can give you special buff for purifying Terras.",
    "ja": "ウォレットアカウントにYuli NFTがある場合は、1日に1回祈る必要があるでしょう。祈りにより、Terrasを浄化するための特別なバフを得ることができます。",
    "zh": "如果你的錢包賬戶裏有 Yuli NFT，你需要每天祈福一次，祈福可以讓你在凈化Terra的時候獲得特殊增益。",
    "zh_cn": "如果你的钱包账户里有 Yuli NFT，你需要每天祈福一次，祈福可以让你在净化Terra的时候获得特殊增益。"
  },
  "home_map_pray_introduce_content_2": {
    "en": "Click Pray button then get your prayer result for today. There are five elements and you may get prayer benefit of one random element.",
    "ja": "「祈る」ボタンをクリックすると、今日の祝福の結果が得られます。 5つの属性のうち1つの属性の祝福バフをランダムで獲得できます。",
    "zh": "點擊「祈禱」按鈕，然後獲取今天的祈福結果。您可以從有五種元素中隨機獲得一種元素的祈福增益。",
    "zh_cn": "点击“祈祷”按钮，然后获取今天的祈福结果。您可以从有五种元素中随机获得一种元素的祈福增益。"
  },
  "home_map_pray_introduce_content_3": {
    "en": "Once you get your prayer benefit, you may enjoy a 10% plus gain when you choose Yuli of the only element to purify Terras.",
    "ja": "祈りバフを取得すると、テラを浄化するときに対応する属性のユリを選択すると、さらに 10% 多くの恩恵を得ることができます。",
    "zh": "一旦你獲得祈福增益，當你在凈化Terra時選擇對應元素的Yuli，你可能獲得額外的10%以上的收益。",
    "zh_cn": "一旦你获得祈福增益，当你在净化Terra时选择对应元素的Yuli，你可能获得额外的10%以上的收益。"
  },
  "home_map_pray_introduce_content_4": {
    "en": "After you get your prayer benefit, you need to pick a Yuli team for purifcation.\nYou can choose three Yulis for the team at most.",
    "ja": "祈りバフを取得したら、浄化するYuliチームを選択する必要があります。\n最大3Yuliを選んでチームを編成できます。",
    "zh": "當你獲得祈禱增益後，你需要選擇一支Yuli隊伍進行凈化。\n您最多可以選擇三只Yuli組成團隊。",
    "zh_cn": "当你获得祈祷增益后，你需要选择一支Yuli队伍进行净化。\n您最多可以选择三只Yuli组成团队。"
  },
  "home_map_pray_introduce_content_5": {
    "en": "Click on Yuli avatar to select or deselect Yuli, and Yuli will be numbered according to selection order. After decided your team pick, click on Continue button.",
    "ja": "Yuli のアバターをクリックして、Yuli を選択または選択解除します。Yuliには選択順に番号が付けられます。選択を確認したら、「続行」ボタンをクリックします。",
    "zh": "點擊Yuli頭像來選擇或取消選擇Yuli。Yuli將根據選擇順序進行編號。確定您的選擇後，單擊「繼續」按鈕。",
    "zh_cn": "点击Yuli头像来选择或取消选择Yuli。Yuli将根据选择顺序进行编号。确定您的选择后，单击“继续”按钮。"
  },
  "home_map_pray_introduce_content_6": {
    "en": "We recommend that you should choose Yulis of high rarity first! Besides that, it will be better if you choose Yulis whose element accord with Prayer Benefit.",
    "ja": "レアリティの高いユリを優先して狙うことをオススメします！それ以外は祈りバフと属性が一致するユリを選んだ方が良いでしょう。",
    "zh": "我們建議您優先選擇稀有度高的Yuli！除此之外，最好選擇元素與祈禱增益一致的Yuli。",
    "zh_cn": "我们建议您优先选择稀有度高的Yuli！除此之外，最好选择元素与祈祷增益一致的Yuli。"
  },
  "home_map_pray_introduce_title_1": {
    "en": "Why to Pray?",
    "ja": "なぜ祈るのか？",
    "zh": "為什麽要祈福？",
    "zh_cn": "为什么要祈福？"
  },
  "home_map_pray_introduce_title_2": {
    "en": "Direction of Prayer",
    "ja": "祈りの手引き",
    "zh": "祈福指南",
    "zh_cn": "祈福指南"
  },
  "home_map_pray_introduce_title_3": {
    "en": "Prayer Benefit",
    "ja": "祈りの利益",
    "zh": "祈福增益",
    "zh_cn": "祈福增益"
  },
  "home_map_pray_introduce_title_4": {
    "en": "Daily Team Pick",
    "ja": "毎日のチーム選択",
    "zh": "每日出陣隊伍選擇",
    "zh_cn": "每日出阵队伍选择"
  },
  "home_map_pray_introduce_title_5": {
    "en": "Direction of Team Pick",
    "ja": "チーム選択ガイド",
    "zh": "隊伍選擇指南",
    "zh_cn": "队伍选择指南"
  },
  "home_map_pray_introduce_title_6": {
    "en": "Tips for Team Pick",
    "ja": "チーム選択のヒント",
    "zh": "隊伍選擇小貼士",
    "zh_cn": "队伍选择小贴士"
  },
  "home_map_pray_invalid": {
    "en": "Pray benefits is invalid, please quit to pray again.",
    "ja": "祈りの獲得は無効です。終了してもう一度祈ってください。",
    "zh": "祈福增益無效，請退出再次祈福",
    "zh_cn": "祈福增益无效，请退出再次祈福"
  },
  "home_map_profit_guaid": {
    "en": "Guaid\n",
    "ja": "Guide",
    "zh": "向導",
    "zh_cn": "向导"
  },
  "home_map_profit_text_total": {
    "en": "Total",
    "ja": "合計",
    "zh": "總計",
    "zh_cn": "总计"
  },
  "home_map_profit_title_light_share": {
    "en": "<%> EARNING TODAY",
    "ja": "<%>の今日の稼ぎ",
    "zh": "<%>今日收益",
    "zh_cn": "<%>今日收益"
  },
  "home_map_profit_title_total": {
    "en": "Total Earning Today",
    "ja": "今日の稼ぎ",
    "zh": "今日總收益",
    "zh_cn": "今日总收益"
  },
  "home_map_profit_title_yuli": {
    "en": "Today Earning",
    "ja": "今日の稼ぎ",
    "zh": "今日收益",
    "zh_cn": "今日收益"
  },
  "home_map_profit_title_yuli_share": {
    "en": "YULI EARNING TODAY",
    "ja": "Yuliの今日の稼ぎ",
    "zh": "Yuli今日收益",
    "zh_cn": "Yuli今日收益"
  },
  "home_map_profit_yuli": {
    "en": "Yuli",
    "ja": "Yuli",
    "zh": "Yuli",
    "zh_cn": "Yuli"
  },
  "home_map_safety_tips_dialog_content": {
    "en": "Please be aware of your surroundings and potential hazard of your play area and be responsible for safety of your own or people nearby while playing our game! Do not play during sports, walking, cycling or driving.",
    "ja": "プレイエリアの周囲と潜在的な危険に注意し、プレイ中は自分自身または近くにいる人の安全に責任を持ってください。運動中、歩行中、自転車や車の運転中にプレイしないでください。",
    "zh": "請註意您周圍的環境和遊戲區域的潛在危險，並在遊戲過程中對您自己或附近人員的安全負責！請勿在運動、步行、騎自行車或駕駛時玩耍。",
    "zh_cn": "请注意您周围的环境和游戏区域的潜在危险，并在游戏过程中对您自己或附近人员的安全负责！请勿在运动、步行、骑自行车或驾驶时玩耍。"
  },
  "home_map_safety_tips_dialog_title": {
    "en": "Safety Tips",
    "ja": "安全のために",
    "zh": "安全提示",
    "zh_cn": "安全提示"
  },
  "home_map_sport_driving": {
    "en": "Please be aware of your surroundings and potential hazard of your play area and be responsible for safety of your own or people nearby while playing our game! Do not play during sports, walking, cycling or driving.",
    "ja": "プレイエリアの周囲と潜在的な危険に注意し、プレイ中は自分自身または近くにいる人の安全に責任を持ってください。運動中、歩行中、自転車や車の運転中にプレイしないでください。",
    "zh": "請註意您周圍的環境和遊戲區域的潛在危險，並在遊戲過程中對您自己或附近人員的安全負責！請勿在運動、步行、騎自行車或駕駛時玩耍。",
    "zh_cn": "请注意您周围的环境和游戏区域的潜在危险，并在游戏过程中对您自己或附近人员的安全负责！请勿在运动、步行、骑自行车或驾驶时玩耍。"
  },
  "home_map_title": {
    "en": "Seek Terra",
    "ja": "Terraを探す",
    "zh": "尋找Terra",
    "zh_cn": "寻找Terra"
  },
  "home_map_top_walker": {
    "en": "Top Walker",
    "ja": "トップウォーカー",
    "zh": "頂尖徒步者",
    "zh_cn": "顶尖徒步者"
  },
  "home_map_unable_terra_signal": {
    "en": "Unable to obtain Terra signal, please move to open erea outdoor and try again.",
    "ja": "Terra 信号を取得できません。屋外のオープンエリアに移動して、もう一度試してください。",
    "zh": "無法獲取Terra信號，請移至室外空曠區域重試。",
    "zh_cn": "无法获取Terra信号，请移至室外空旷区域重试。"
  },
  "home_map_week_refresh": {
    "en": "Refresh at 20:00 UTC+0 every Sunday",
    "ja": "毎週日曜日 20:00 UTC+0 に更新します",
    "zh": "每周日 20:00 UTC+0 刷新",
    "zh_cn": "每周日 20:00 UTC+0 刷新"
  },
  "home_map_yuli_info_base_buffs": {
    "en": "Base Buffs ",
    "ja": "ベースバフ",
    "zh": "基礎增益",
    "zh_cn": "基础增益"
  },
  "home_map_yuli_info_dialog_title": {
    "en": "Yuli info",
    "ja": "Yuli情報",
    "zh": "Yuli信息",
    "zh_cn": "Yuli信息"
  },
  "home_map_yuli_info_exp": {
    "en": "EXP",
    "ja": "EXP",
    "zh": "EXP",
    "zh_cn": "EXP"
  },
  "home_map_yuli_joyful_content": {
    "en": "Prayer benefit / Elements Buff",
    "ja": "祈りバフまたはエレメンタルバフのいずれかを所持",
    "zh": "擁有祈福增益或元素增益其中一種",
    "zh_cn": "拥有祈福增益或元素增益其中一种"
  },
  "home_map_yuli_joyful_msg": {
    "en": "It's time to do what we need to do now!",
    "ja": "今こそやるべきことをやる時です！",
    "zh": "現在是時候做我們該做的事情了！",
    "zh_cn": "现在是时候做我们该做的事情了！"
  },
  "home_map_yuli_joyful_title": {
    "en": "Joyful",
    "ja": "喜び",
    "zh": "愉悅",
    "zh_cn": "愉悦"
  },
  "home_map_yuli_mood_dialog_title": {
    "en": "Yuli's Mood",
    "ja": "ユリの気分",
    "zh": "Yuli的心情",
    "zh_cn": "Yuli的心情"
  },
  "home_map_yuli_normal_content": {
    "en": "Normal state with no Buff / Debuff",
    "ja": "通常状態、バフ/デバフなし",
    "zh": "正常狀態，無增益/減益",
    "zh_cn": "正常状态，无增益/减益"
  },
  "home_map_yuli_normal_msg": {
    "en": "On duty now, capable for Terra purifying.",
    "ja": "現在勤務中で、テラの浄化が可能です。",
    "zh": "出陣中，能夠凈化Terra",
    "zh_cn": "出阵中，能够净化Terra"
  },
  "home_map_yuli_normal_title": {
    "en": "Normal",
    "ja": "普通",
    "zh": "一般",
    "zh_cn": "一般"
  },
  "home_map_yuli_overjoyed_content": {
    "en": "Prayer benefit & Elements Buff",
    "ja": "祈りバフかエレメンタルバフのいずれかを所持",
    "zh": "同時擁有祈福增益和元素增益",
    "zh_cn": "同时拥有祈福增益和元素增益"
  },
  "home_map_yuli_overjoyed_msg": {
    "en": "Hurry, hurry, let's go out to purify the Terra!",
    "ja": "急いで、Terraを浄化しに行きましょう！",
    "zh": "快，我們出門凈化Terra吧！",
    "zh_cn": "快，我们出门净化Terra吧！"
  },
  "home_map_yuli_overjoyed_title": {
    "en": "Cheerful",
    "ja": "興奮",
    "zh": "興奮",
    "zh_cn": "兴奋"
  },
  "home_map_yuli_terrible_content": {
    "en": "Lack of Sanity & no more Shield",
    "ja": "精神力もシールド値も足りない",
    "zh": "精神力和護盾值都不足",
    "zh_cn": "精神力和护盾值都不足"
  },
  "home_map_yuli_terrible_msg": {
    "en": "Forget about purifying now !\nDo something right!",
    "ja": "もう浄化のことは忘れてください！\n何か正しいことをしてください！",
    "zh": "現在忘記凈化吧！\n做正確的事！",
    "zh_cn": "现在忘记净化吧！\n做正确的事！"
  },
  "home_map_yuli_terrible_title": {
    "en": "Terrible",
    "ja": "怒り",
    "zh": "生氣",
    "zh_cn": "生气"
  },
  "home_map_yuli_upset_content": {
    "en": "Lack of Sanity / no more Shield",
    "ja": "精神力またはシールド値のいずれかが不足しています",
    "zh": "精神力或護盾值有一項不足",
    "zh_cn": "精神力或护盾值有一项不足"
  },
  "home_map_yuli_upset_msg": {
    "en": "You are not recommended to purify Terras now...",
    "ja": "今Terras を浄化することはお勧めできません...",
    "zh": "現在不建議您凈化Terra……",
    "zh_cn": "现在不建议您净化Terra……"
  },
  "home_map_yuli_upset_title": {
    "en": "Upset",
    "ja": "憂鬱",
    "zh": "沮喪",
    "zh_cn": "沮丧"
  },
  "home_mission_pass": {
    "en": "MISSION PASS",
    "ja": "ミッションパス",
    "zh": "任務通行證",
    "zh_cn": "任务通行证"
  },
  "home_no_enough_bal": {
    "en": "insufficient balance, please try again later",
    "ja": "残高が不足しています。",
    "zh": "餘額不足，請稍後再試",
    "zh_cn": "余额不足，请稍后再试"
  },
  "home_no_operation_long_time": {
    "en": "No operation for long time, please re-enter the game.",
    "ja": "長時間操作がなかった場合は、ゲームを再起動してください。",
    "zh": "長時間無操作，請重啟遊戲。",
    "zh_cn": "长时间无操作，请重启游戏。"
  },
  "home_no_wallet_msg": {
    "en": "You can not use these fuctions before you import your wallet account again.",
    "ja": "ウォレットアカウントを再度インポートするまで、これらの機能は使用できません。",
    "zh": "您無法使用這些功能，請重新導入錢包賬戶。",
    "zh_cn": "您无法使用这些功能，请重新导入钱包账户。"
  },
  "home_no_wallet_titles": {
    "en": "Unable To Use Now!",
    "ja": "今使用できません!",
    "zh": "現在無法使用！",
    "zh_cn": "现在无法使用！"
  },
  "home_not_login_toast": {
    "en": "You are in Quick Play mode now, you cannot experience full functionality unless you have logged in",
    "ja": "現在クイックプレイモードになっています。ログインしないとすべての機能を体験することはできません。",
    "zh": "您現在處於遊客模式，未登錄無法體驗完整功能",
    "zh_cn": "您现在处于游客模式，未登录无法体验完整功能"
  },
  "home_pack": {
    "en": "Pack",
    "ja": "バッグ",
    "zh": "背包",
    "zh_cn": "背包"
  },
  "home_permission_notification_content": {
    "en": "In order to inform you with news, airdrops and messages, allow Yulimeta to use your notification all of the time. \n\nYulimeta use your notification to notify activities in the app, even when the app is closed or not in use. ",
    "ja": "YLVSの通知権限を常にONにして、お知らせやエアドロップ、メッセージを通知できるようにしてください。\nYulimetaは通知権限を使用してアプリ内アクティビティを通知します。また、アプリが閉じられているときや使用されていないときにタイムリーに通知を受け取ることもできます。",
    "zh": "請允許 Yulimeta 始終使用您的通知權限，用於向您通知公告、空投和消息。\nYulimeta 使用您的通知權限來通知您應用內的活動，當應用程序已關閉或未使用的時候您也能及時收到通知。",
    "zh_cn": "请允许 Yulimeta 始终使用您的通知权限，用于向您通知公告、空投和消息。\nYulimeta 使用您的通知权限来通知您应用内的活动，当应用程序已关闭或未使用的时候您也能及时收到通知。"
  },
  "home_permission_notification_title": {
    "en": "Use Your Notification",
    "ja": "通知機能を使う",
    "zh": "使用您的通知權限",
    "zh_cn": "使用您的通知权限"
  },
  "home_permissions_denied_notifications": {
    "en": "You cannot receive notifications unless you are authorized to notifications.",
    "ja": "通知権限が承認されていないため、通知を受信できません。",
    "zh": "未授權通知權限，無法接收通知。",
    "zh_cn": "未授权通知权限，无法接收通知。"
  },
  "home_points_error_content_1": {
    "en": "Adding points failed, please try again later.",
    "ja": "\nポイントの追加に失敗しました。後でもう一度お試しください。",
    "zh": "加點失敗，請稍後重試",
    "zh_cn": "加点失败，请稍后重试"
  },
  "home_possess_content": {
    "en": "All Yuli are minted from mystery box. You canget Yuli or mystery box by participating inofficial events or buying from the secondarymarket(Opensea, Element, Tofu, etc).",
    "ja": "すべてのYuliはミステリーボックスから出てきます。Yuliまたはミステリーボックスは、公式イベントに参加するか、二次流通マーケット (Opensea、Element、Tofu など) から購入することで入手できます。",
    "zh": "所有Yuli都是從神秘盒子中鑄造出來的。Yuli或神秘盒子可以通過參加官方活動或從二級市場（Opensea、Element、Tofu等）購買獲得。",
    "zh_cn": "所有Yuli都是从神秘盒子中铸造出来的。Yuli或神秘盒子可以通过参加官方活动或从二级市场（Opensea、Element、Tofu等）购买获得。"
  },
  "home_possess_title": {
    "en": "How to get Yuli?",
    "ja": "Yuliを入手？",
    "zh": "如何獲得Yuli？",
    "zh_cn": "如何获得Yuli？"
  },
  "home_pray_fail_content": {
    "en": "The new day is here, please return to Home and start a new journey.",
    "ja": "新しい日がやって来ました、ホームページに戻って新しい旅を始めてください。",
    "zh": "新的一天已經到來，請回到主頁，開始新的征程。",
    "zh_cn": "新的一天已经到来，请回到主页，开始新的征程。"
  },
  "home_quick_play_login": {
    "en": "log in",
    "ja": "ログイン",
    "zh": "登錄",
    "zh_cn": "登录"
  },
  "home_role_content": {
    "en": "Yuli is divided into six rarities in total, fromow to high:Prototype, Common, UncommonSuperior, Epic, and Legendary. The higher thelevel, the more benefits you will earn.",
    "ja": "Yuliは、低い順に、プロトタイプ、コモン、アンコモン、スーペリア、エピック、レジェンダリーの合計 6 つのレアリティに分類されます。レベルが高いほど、より多くの恩恵を受けられます。",
    "zh": "Yuli總共分為六種稀有度，從低到高依次為：原型、普通、罕見、高級、史詩、傳奇。級別越高，您獲得的好處就越多。",
    "zh_cn": "Yuli总共分为六种稀有度，从低到高依次为：原型、普通、罕见、高级、史诗、传奇。级别越高，您获得的好处就越多。"
  },
  "home_role_full_hp_toast": {
    "en": " Sanity is full, no need to recover",
    "ja": "精神力は満タンなので回復する必要はない",
    "zh": "體力已滿，無需恢復",
    "zh_cn": "体力已满，无需恢复"
  },
  "home_role_hp_content": {
    "en": "Recover based on every 30 points",
    "ja": "1回につき30ポイント回復",
    "zh": "一次恢復30點",
    "zh_cn": "一次恢复30点"
  },
  "home_role_hp_err_title": {
    "en": "Recover Sanity\n",
    "ja": "精神力を回復する",
    "zh": "恢復體力",
    "zh_cn": "恢复体力"
  },
  "home_role_hp_err_toast": {
    "en": "There are 10 points of overflow in Sanity recover this time which won't return,and you cannot continue to recover Your Sanity since it will befull.Are you sure to continue?",
    "ja": "回復量が最大精神力より10ポイントオーバーしています。精神力は上限以上に回復せず、オーバーフローしたポイントは戻ってきません。続行してもよろしいですか？",
    "zh": "本次體力恢復有10點溢出，溢出點數不會返還，當體力已達到上限時無法繼續恢復，確定要繼續嗎？",
    "zh_cn": "本次体力恢复有10点溢出，溢出点数不会返还，当体力已达到上限时无法继续恢复，确定要继续吗？"
  },
  "home_role_hp_title": {
    "en": "Recover Sanity",
    "ja": "精神力を回復する",
    "zh": "恢復體力",
    "zh_cn": "恢复体力"
  },
  "home_role_hp_toast": {
    "en": "Sanity recover success",
    "ja": "精神力回復成功",
    "zh": "體力恢復成功",
    "zh_cn": "体力恢复成功"
  },
  "home_role_title": {
    "en": "Rarities of Yuli",
    "ja": "Yuliのレアリティ",
    "zh": "Yuli的稀有度",
    "zh_cn": "Yuli的稀有度"
  },
  "home_seek": {
    "en": "Seek",
    "ja": "Terra",
    "zh": "凈化",
    "zh_cn": "净化"
  },
  "home_seek_terra": {
    "en": "Seek Terra",
    "ja": "Terraを探す",
    "zh": "凈化地脈",
    "zh_cn": "净化地脉"
  },
  "home_share_successfu": {
    "en": "Share successful",
    "ja": "共有が成功しました",
    "zh": "分享成功",
    "zh_cn": "分享成功"
  },
  "home_shop": {
    "en": "Shop",
    "ja": "ショップ",
    "zh": "商城",
    "zh_cn": "商城"
  },
  "home_shop_arg_balance": {
    "en": "Insufficient ARG Balance, unable to purchase.",
    "ja": "ARG残高不足のため購入できません。",
    "zh": "ARG余額不足，無法購買。",
    "zh_cn": "ARG余额不足，无法购买。"
  },
  "home_shop_art_balance": {
    "en": "Insufficient ART Balance, unable to purchase.",
    "ja": "ART残高不足のため購入できません。",
    "zh": "ART余額不足，無法購買",
    "zh_cn": "ART余额不足，无法购买"
  },
  "home_shop_bought_success": {
    "en": "You have bought successfully +",
    "ja": "購入成功、数量 +",
    "zh": "購買成功，數量+",
    "zh_cn": "购买成功，数量+"
  },
  "home_shop_close": {
    "en": "Close",
    "ja": "閉じる",
    "zh": "關閉",
    "zh_cn": "关闭"
  },
  "home_shop_confirm": {
    "en": "Confirm",
    "ja": "確認",
    "zh": "確認",
    "zh_cn": "确认"
  },
  "home_shop_daily": {
    "en": "Daily",
    "ja": "毎日",
    "zh": "每天",
    "zh_cn": "每天"
  },
  "home_shop_left": {
    "en": "Left: ",
    "ja": "残り：",
    "zh": "剩余：",
    "zh_cn": "剩余："
  },
  "home_shop_new": {
    "en": "New",
    "ja": "NEW",
    "zh": "新",
    "zh_cn": "新"
  },
  "home_shop_no_props": {
    "en": "No props in your shop",
    "ja": "ショップにアイテムはありません",
    "zh": "商店裏沒有道具",
    "zh_cn": "商店里没有道具"
  },
  "home_shop_no_props_in_your_shop": {
    "en": "No props in your shop",
    "ja": "ショップにアイテムはありません",
    "zh": "商店中無道具",
    "zh_cn": "商店中无道具"
  },
  "home_shop_not_more": {
    "en": "Not more available for purchase",
    "ja": "これ以上購入できません",
    "zh": "已達購買上限",
    "zh_cn": "已达购买上限"
  },
  "home_shop_opps": {
    "en": "Opps!....",
    "ja": "おっと！",
    "zh": "哎呀！",
    "zh_cn": "哎呀！"
  },
  "home_shop_pay_content": {
    "en": "The balance of your Growth Reward is not enough to cover this transaction, so you need to pay ARG to finish the transaction.",
    "ja": "GARGの残高ではこの取引をカバーするのに十分ではないため、取引を完了するには ARG に支払う必要があります。",
    "zh": "您的GARG余額不足以支付本次交易，因此您需要支付ARG來完成交易。",
    "zh_cn": "您的GARG余额不足以支付本次交易，因此您需要支付ARG来完成交易。"
  },
  "home_shop_prop_purchase": {
    "en": "Prop Purchase",
    "ja": "アイテム購入",
    "zh": "道具購買",
    "zh_cn": "道具购买"
  },
  "home_shop_ranking_null": {
    "en": "Ranking list is being updated...",
    "ja": "ランキングリストは更新中です...",
    "zh": "排行榜正在更新中...",
    "zh_cn": "排行榜正在更新中..."
  },
  "home_shop_refresh_utc0_every_day": {
    "en": "Refresh at 0 UTC+0 every day",
    "ja": "毎日 0 UTC+0 に更新します",
    "zh": "每天 0 UTC+0 刷新",
    "zh_cn": "每天 0 UTC+0 刷新"
  },
  "home_shop_refresh_utc0_every_week": {
    "en": "Refresh at 0 UTC+0 every Monday",
    "ja": "毎週月曜日 0 UTC+0 に更新します",
    "zh": "每周一 0 UTC+0 刷新",
    "zh_cn": "每周一 0 UTC+0 刷新"
  },
  "home_shop_refreshes": {
    "en": "Refreshes in:",
    "ja": "更新時期:",
    "zh": "刷新時間：",
    "zh_cn": "刷新时间："
  },
  "home_shop_sold_out": {
    "en": "SOLD OUT",
    "ja": "完売",
    "zh": "售罄",
    "zh_cn": "售罄"
  },
  "home_shop_sure_to_continue": {
    "en": "Sure To Continue?",
    "ja": "続けますか?",
    "zh": "確定繼續嗎？",
    "zh_cn": "确定继续吗？"
  },
  "home_shop_top_buyers": {
    "en": "Top Buyers",
    "ja": "トップバイヤー",
    "zh": "買家排行",
    "zh_cn": "买家排行"
  },
  "home_shop_view_all": {
    "en": "View all",
    "ja": "すべて見る",
    "zh": "查看全部",
    "zh_cn": "查看全部"
  },
  "home_shop_weekly": {
    "en": "Weekly",
    "ja": "毎週",
    "zh": "每周",
    "zh_cn": "每周"
  },
  "home_shop_you_pay_arg": {
    "en": "you need to pay ARG",
    "ja": "ARGを支払う必要があります",
    "zh": "你需要支付ARG",
    "zh_cn": "你需要支付ARG"
  },
  "home_stamina_cancel": {
    "en": "Cancel",
    "ja": "キャンセル",
    "zh": "取消",
    "zh_cn": "取消"
  },
  "home_stamina_confirm": {
    "en": "Confirm",
    "ja": "確認",
    "zh": "確認",
    "zh_cn": "确认"
  },
  "home_stamina_max": {
    "en": "MAX",
    "ja": "最大値",
    "zh": "最大值",
    "zh_cn": "最大值"
  },
  "home_stamina_num": {
    "en": "Num",
    "ja": "数量",
    "zh": "數量",
    "zh_cn": "数量"
  },
  "home_stamina_overflow_content": {
    "en": "There are <%> points of overflow in Sanity recover this time which won't return, and you cannot continue to recover Yuli's Sanity since it will be full. Are you sure to continue?",
    "ja": "回復量が最大精神力より<%>ポイントオーバーしています。精神力は上限以上に回復せず、オーバーフローしたポイントは戻ってきません。続行してもよろしいですか？",
    "zh": "本次體力恢復有<%>點溢出，溢出點數不會返還，當體力已達到上限時無法繼續恢復，確定要繼續嗎？",
    "zh_cn": "本次体力恢复有<%>点溢出，溢出点数不会返还，当体力已达到上限时无法继续恢复，确定要继续吗？"
  },
  "home_stamina_overflow_title": {
    "en": "Sure to Recover?",
    "ja": "回復しますか?",
    "zh": "確定要恢復嗎？",
    "zh_cn": "确定要恢复吗？"
  },
  "home_stamina_recover": {
    "en": "Recover",
    "ja": "回復",
    "zh": "恢復",
    "zh_cn": "恢复"
  },
  "home_stamina_toast_conten_1": {
    "en": "Stamina has been recovered +<%>",
    "ja": "精神力が回復+<%>",
    "zh": "精神力恢復<%>點",
    "zh_cn": "精神力恢复<%>点"
  },
  "home_stardust": {
    "en": "MISSION STARDUST\nreborn or the end",
    "ja": "ミッションスターダスト\n生まれ変わるか、終わりか",
    "zh": "星塵任務\n重生或滅亡",
    "zh_cn": "星尘任务\n"
  },
  "home_terra": {
    "en": "Terra",
    "ja": "を探す",
    "zh": "地脉",
    "zh_cn": "地脉"
  },
  "home_tip_empty_yuli": {
    "en": "You cannot view this page unless you obtain Yuli to your wallet account first.",
    "ja": "ウォレットに Yuli が入っていないため、このページを表示できません",
    "zh": "您的錢包裏沒有Yuli，無法查看此頁面",
    "zh_cn": "您的钱包里没有Yuli，无法查看此页面"
  },
  "home_title": {
    "en": "What's Yuli?",
    "ja": "Yuliとは？",
    "zh": "什麽是Yuli？",
    "zh_cn": "什么是Yuli？"
  },
  "home_unable_to_purify_terra_content": {
    "en": "Your Guide and Yulis have no enough Shields currently, which may lead to a abortive result of purification.\nPlease wait patiently for the Shields refresh before purifying Terras.",
    "ja": "ガイドとユリスは現在、浄化するのに十分なシールドを持っていません。\nTerraを浄化する前に、シールド値が更新されるまで辛抱強く待ってください。",
    "zh": "您的向導和Yuli目前沒有足夠的護盾，無法進行凈化。\n請耐心等待護盾值刷新後再凈化Terra。",
    "zh_cn": "您的向导和Yuli目前没有足够的护盾，无法进行净化。\n请耐心等待护盾值刷新后再净化Terra。"
  },
  "home_unable_to_purify_terra_title": {
    "en": "Unable to Purify Terra",
    "ja": "Terraを浄化できません",
    "zh": "无法净化Terra",
    "zh_cn": "无法净化Terra"
  },
  "home_wallet": {
    "en": "Wallet",
    "ja": "Wallet",
    "zh": "錢包",
    "zh_cn": "钱包"
  },
  "home_yuli": {
    "en": "Yuli",
    "ja": "Yuli",
    "zh": "Yuli",
    "zh_cn": "Yuli"
  },
  "home_yuli_ prop_shop": {
    "en": "No recover prop currently, please purchase in shop.",
    "ja": "現在回復アイテムはありません。ショップで購入してください。",
    "zh": "道具不足，請從商店購買",
    "zh_cn": "道具不足，请从商店购买"
  },
  "home_yuli_advance": {
    "en": "Advance",
    "ja": "進化",
    "zh": "進化",
    "zh_cn": "进化"
  },
  "home_yuli_agglomeration": {
    "en": "Agglomeration",
    "ja": "Agglomeration",
    "zh": "Agglomeration",
    "zh_cn": "Agglomeration"
  },
  "home_yuli_analysis": {
    "en": "Analysis",
    "ja": "Analysis",
    "zh": "Analysis",
    "zh_cn": "Analysis"
  },
  "home_yuli_attributes": {
    "en": "Attributes",
    "ja": "能力値",
    "zh": "屬性",
    "zh_cn": "属性"
  },
  "home_yuli_awaken": {
    "en": "Awaken",
    "ja": "Awaken",
    "zh": "Awaken",
    "zh_cn": "Awaken"
  },
  "home_yuli_breed_count": {
    "en": "Breed count",
    "ja": "ブリード回数",
    "zh": "繁育次數",
    "zh_cn": "繁育次数"
  },
  "home_yuli_compile": {
    "en": "Compile",
    "ja": "Compile",
    "zh": "Compile",
    "zh_cn": "Compile"
  },
  "home_yuli_continuance": {
    "en": "Continuance",
    "ja": "Continuance",
    "zh": "Continuance",
    "zh_cn": "Continuance"
  },
  "home_yuli_id_copy_success": {
    "en": "Yuli ID copied successfully",
    "ja": "Yuli IDがコピーされました",
    "zh": "Yuli ID 復製成功",
    "zh_cn": "Yuli ID 复制成功"
  },
  "home_yuli_infos": {
    "en": "Infos",
    "ja": "情報",
    "zh": "信息",
    "zh_cn": "信息"
  },
  "home_yuli_meditation": {
    "en": "Meditation",
    "ja": "Meditation",
    "zh": "Meditation",
    "zh_cn": "Meditation"
  },
  "home_yuli_type_fire": {
    "en": "Fire",
    "ja": "火",
    "zh": "火",
    "zh_cn": "火"
  },
  "home_yuli_type_ice": {
    "en": "Ice",
    "ja": "氷",
    "zh": "冰",
    "zh_cn": "冰"
  },
  "home_yuli_type_rock": {
    "en": "Rock",
    "ja": "石",
    "zh": "巖",
    "zh_cn": "岩"
  },
  "home_yuli_type_thunder": {
    "en": "Thunder",
    "ja": "雷",
    "zh": "雷",
    "zh_cn": "雷"
  },
  "home_yuli_type_wind": {
    "en": "Wind",
    "ja": "風",
    "zh": "風",
    "zh_cn": "风"
  },
  "notify_airdrop_claim_button": {
    "en": "Claim",
    "ja": "受け取る",
    "zh": "領取",
    "zh_cn": "领取"
  },
  "notify_airdrop_claimed_button": {
    "en": "Claimed",
    "ja": "受け取り済",
    "zh": "已領取",
    "zh_cn": "已领取"
  },
  "notify_airdrop_received_gifts_failed": {
    "en": "Received gifts failed",
    "ja": "受け取りに失敗しました",
    "zh": "領取失敗",
    "zh_cn": "领取失败"
  },
  "notify_airdrop_title": {
    "en": "Airdrop Gift",
    "ja": "エアドロップギフト",
    "zh": "空投禮物",
    "zh_cn": "空投礼物"
  },
  "notify_anc_clear": {
    "en": "Clear",
    "ja": "クリア",
    "zh": "清除",
    "zh_cn": "清除"
  },
  "notify_anc_event": {
    "en": "Event",
    "ja": "イベント",
    "zh": "活動",
    "zh_cn": "活动"
  },
  "notify_anc_news": {
    "en": "News",
    "ja": "ニュース",
    "zh": "資訊",
    "zh_cn": "资讯"
  },
  "notify_anc_title": {
    "en": "What's New？",
    "ja": "新着情報",
    "zh": "公告",
    "zh_cn": "公告"
  },
  "notify_anc_update": {
    "en": "Update",
    "ja": "アップデート",
    "zh": "更新",
    "zh_cn": "更新"
  },
  "notify_notify_empty": {
    "en": "No contents currently",
    "ja": "今は何もありません",
    "zh": "當前無內容",
    "zh_cn": "当前无内容"
  },
  "notify_notify_permisson_content": {
    "en": "In order to inform you with news, airdrops and messages, allow Yulimeta to use your notification all of the time.\nYulimeta use your notification to notify activities in the app, even when the app is closed or not in use. ",
    "ja": "Yulimeta の通知権限を常にONにして、お知らせやエアドロップ、メッセージを通知できるようにしてください。\nYLVS は通知権限を使用してアプリ内アクティビティを通知します。また、アプリが閉じられているときや使用されていないときにタイムリーに通知を受け取ることもできます。",
    "zh": "請允許Yulimeta始終使用您的通知權限，用於向您通知公告、空投和消息。\nYulimeta使用您的通知權限來通知您應用內的活動，當應用程序已關閉或未使用的時候您也能及時收到通知。",
    "zh_cn": "请允许Yulimeta始终使用您的通知权限，用于向您通知公告、空投和消息。\nYulimeta使用您的通知权限来通知您应用内的活动，当应用程序已关闭或未使用的时候您也能及时收到通知。"
  },
  "notify_notify_permisson_title": {
    "en": "Use Your Notification",
    "ja": "通知機能を使う",
    "zh": "使用您的通知權限",
    "zh_cn": "使用您的通知权限"
  },
  "notify_permisson_content_ios": {
    "en": "You cannot use notification unless your notification be authorized.",
    "ja": "通知権限が承認されていないため、通知を受信できません。",
    "zh": "未授權通知權限，無法接收通知。",
    "zh_cn": "未授权通知权限，无法接收通知。"
  },
  "stardust_about": {
    "en": "Collect Stardust and win special rewards!",
    "ja": "\nスターダストを集めて特別な報酬を獲得しましょう！",
    "zh": "收集星塵並贏得特殊獎勵！",
    "zh_cn": "收集星尘并赢得特殊奖励！"
  },
  "stardust_activate": {
    "en": "Activate",
    "ja": "アクティベート",
    "zh": "激活",
    "zh_cn": "激活"
  },
  "stardust_activate_button": {
    "en": "Activate now",
    "ja": "アクティベートする",
    "zh": "立即激活",
    "zh_cn": "立即激活"
  },
  "stardust_activate_code_toast": {
    "en": "Input app code to activate and claim rewards",
    "ja": "アプリコードを入力してアクティベートし、特典を受け取ります",
    "zh": "輸入應用碼激活並獲得獎勵",
    "zh_cn": "输入应用码激活并获得奖励"
  },
  "stardust_activate_fail_toast": {
    "en": "Invalid app code, please re-enter",
    "ja": "アプリコードが無効です。再入力してください。",
    "zh": "應用碼無效，請重新輸入",
    "zh_cn": "应用码无效，请重新输入"
  },
  "stardust_activated": {
    "en": "Activated",
    "ja": "アクティベート済",
    "zh": "已激活",
    "zh_cn": "已激活"
  },
  "stardust_app_activate_code": {
    "en": "App code Activation Rewards",
    "ja": "アプリコードのアクティベーション特典",
    "zh": "應用碼激活獎勵",
    "zh_cn": "应用码激活奖励"
  },
  "stardust_app_code": {
    "en": "App Code",
    "ja": "アプリコード",
    "zh": "應用碼",
    "zh_cn": "应用码"
  },
  "stardust_balance_insufficient": {
    "en": "Your Stardust balance is insufficient. You can replenish it by purchasing Stardust.",
    "ja": "スターダストの残高が不足しています。スターダストを購入することで補充できます",
    "zh": "您的星塵余額不足，您可以通過購買星塵補充。",
    "zh_cn": "您的星尘余额不足，您可以通过购买星尘补充。"
  },
  "stardust_claim_button": {
    "en": "Claim",
    "ja": "受け取る",
    "zh": "領取",
    "zh_cn": "领取"
  },
  "stardust_claim_reward_toast": {
    "en": "App code activation Rewards",
    "ja": "アプリコードのアクティベーション特典",
    "zh": "應用碼激活獎勵",
    "zh_cn": "应用码激活奖励"
  },
  "stardust_claim_rewards": {
    "en": "Claim Rewards",
    "ja": "報酬を受け取る",
    "zh": "領取獎勵",
    "zh_cn": "领取奖励"
  },
  "stardust_connect_wallet": {
    "en": "Connect wallet to unlock",
    "ja": "ウォレットを接続してロックを解除する",
    "zh": "鏈接錢包解鎖",
    "zh_cn": "链接钱包解锁"
  },
  "stardust_daily_reward": {
    "en": "Daily Collection Rewards",
    "ja": "毎日の収集報酬",
    "zh": "每日收集獎勵",
    "zh_cn": "每日收集奖励"
  },
  "stardust_each_invite": {
    "en": " each invitation",
    "ja": "１招待ごとに",
    "zh": "每完成一次邀請",
    "zh_cn": "每完成一次邀请"
  },
  "stardust_everyday": {
    "en": "Everyday",
    "ja": "毎日",
    "zh": "每日",
    "zh_cn": "每日"
  },
  "stardust_exchange_desc": {
    "en": "Exchange Stardust for Special Items",
    "ja": "スターダストを特別なアイテムと交換する",
    "zh": "使用星塵兌換特殊道具",
    "zh_cn": "使用星尘兑换特殊道具"
  },
  "stardust_friends_invite": {
    "en": "Friends invitation Rewards",
    "ja": "友達招待の報酬",
    "zh": "邀請好友獎勵",
    "zh_cn": "邀请好友奖励"
  },
  "stardust_go_to_purchase": {
    "en": "Go to purchase",
    "ja": "購入へ",
    "zh": "去購買",
    "zh_cn": "去购买"
  },
  "stardust_input_code": {
    "en": "Input a code",
    "ja": "コードを入力してください",
    "zh": "輸入代碼",
    "zh_cn": "输入代码"
  },
  "stardust_invitation_code_copied": {
    "en": "Invitation code copied",
    "ja": "招待コードをコピーしました",
    "zh": "已復製邀請碼",
    "zh_cn": "已复制邀请码"
  },
  "stardust_invitation_code_empty": {
    "en": "Input box cannot be empty",
    "ja": "入力ボックスは空欄にできません",
    "zh": "輸入框不能為空",
    "zh_cn": "输入框不能为空"
  },
  "stardust_invitation_code_tips": {
    "en": "Invitation code is empty",
    "ja": "招待コードが空です",
    "zh": "邀請碼為空",
    "zh_cn": "邀请码为空"
  },
  "stardust_invite_count": {
    "en": "Invite Counts",
    "ja": "招待数",
    "zh": "邀請次數",
    "zh_cn": "邀请次数"
  },
  "stardust_limit": {
    "en": "Limit: ",
    "ja": "制限：",
    "zh": "限製：",
    "zh_cn": "限制："
  },
  "stardust_limit_per_day": {
    "en": "Limit: <%> per day",
    "ja": "制限：<%>/日",
    "zh": "限製： <%>/天",
    "zh_cn": "限制： <%>/天"
  },
  "stardust_long_term": {
    "en": "Long-term",
    "ja": "長期",
    "zh": "長期",
    "zh_cn": "长期"
  },
  "stardust_mission": {
    "en": "Mission",
    "ja": "ミッション",
    "zh": "任務",
    "zh_cn": "任务"
  },
  "stardust_my_code": {
    "en": "My Code",
    "ja": "私のコード",
    "zh": "我的應用碼",
    "zh_cn": "我的应用码"
  },
  "stardust_not_completed": {
    "en": "Not completed",
    "ja": "未達成",
    "zh": "未完成",
    "zh_cn": "未完成"
  },
  "stardust_not_eligible": {
    "en": "Not eligible",
    "ja": "対象外",
    "zh": "條件不符合",
    "zh_cn": "条件不符合"
  },
  "stardust_one_time": {
    "en": "One-time",
    "ja": "1度のみ",
    "zh": "一次性",
    "zh_cn": "一次性"
  },
  "stardust_own": {
    "en": "Own",
    "ja": "所有",
    "zh": "持有",
    "zh_cn": "持有"
  },
  "stardust_project_content": {
    "en": "Stardust Collection\n1 . Stardust can be obtained throughvarious tasks, including one-time tasksand daily tasks. Tasks will be dividedbetween the Stardust event on theofficial website and the in-app event,and the task details can be viewed onthe task list. Daily tasks will refreshevery day at 00:00 UTC+8\nStardust redemption2. In the Stardust event on the officialwebsite, a variety of rewards will be\nperiodically made available for playersto redeem.",
    "ja": "スターダストコレクション\n1.スターダストは、単発タスクや毎日のタスクなど、さまざまなタスクを通じて獲得できます。タスクは公式サイトのスターダストイベントとアプリ内イベントに分かれており、タスクの詳細はタスクリストで確認できます。日次タスクは毎日 00:00 UTC+8 のスターダスト再出現と共に更新されます。\n\n２．公式サイトのスターダストイベントでは、さまざまな報酬が定期的に登場し、引き換えることができます。",
    "zh": "星塵收集\n1.星塵可以通過各種任務獲得，包括一次性任務和日常任務。任務將分為官網星塵活動和應用內活動，任務詳情可在任務列表中查看。每日任務將於每天 00:00 UTC+8 刷新\n星塵的救贖\n2.官網星塵活動中，將有多種獎勵定期提供給玩家兌換。",
    "zh_cn": "星尘收集\n1.星尘可以通过各种任务获得，包括一次性任务和日常任务。任务将分为官网星尘活动和应用内活动，任务详情可在任务列表中查看。每日任务将于每天 00:00 UTC+8 刷新\n星尘的救赎\n2.官网星尘活动中，将有多种奖励定期提供给玩家兑换。"
  },
  "stardust_project_title": {
    "en": "Stardust Project",
    "ja": "スターダストプロジェクト",
    "zh": "星塵項目",
    "zh_cn": "星尘项目"
  },
  "stardust_purchase": {
    "en": "Purchase",
    "ja": "購入",
    "zh": "購買",
    "zh_cn": "购买"
  },
  "stardust_purchase_desc": {
    "en": "You will spend <%1> Stardust to purchase <%2>. Are you sure you want to continue?",
    "ja": "<%2> を購入するには <%1> のスターダストを使用します。続行してもよろしいですか?",
    "zh": "您將花費 <%1> 星塵購買<%2>。您確定要繼續嗎？",
    "zh_cn": "您将花费 <%1> 星尘购买<%2>。您确定要继续吗？"
  },
  "stardust_purchase_failed": {
    "en": "Purchase failed",
    "ja": "購入に失敗しました",
    "zh": "購買失敗",
    "zh_cn": "购买失败"
  },
  "stardust_recharge": {
    "en": "Recharge",
    "ja": "リチャージ",
    "zh": "充值",
    "zh_cn": "充值"
  },
  "stardust_rewards": {
    "en": "Rewards ",
    "ja": "報酬",
    "zh": "獎勵",
    "zh_cn": "奖励"
  },
  "stardust_rules": {
    "en": "Rules",
    "ja": "ルール",
    "zh": "規則",
    "zh_cn": "规则"
  },
  "stardust_sign_up": {
    "en": "App Sign-up Rewards",
    "ja": "サインアップリワード",
    "zh": "應用簽到獎勵",
    "zh_cn": "应用签到奖励"
  },
  "stardust_stardust_store": {
    "en": "Stardust Store",
    "ja": "スターダストストア",
    "zh": "星塵商店",
    "zh_cn": "星尘商店"
  },
  "stardust_task_content": {
    "en": "Sign up Yulimeta app and complete wallet connection with current account",
    "ja": "Yulimeta アプリにサインアップし、現在のアカウントでウォレット接続を完了します",
    "zh": "註冊 Yulimeta 應用並與當前賬戶完成錢包連接",
    "zh_cn": "注册 Yulimeta 应用并与当前账户完成钱包连接"
  },
  "stardust_task_content2": {
    "en": "Activate other users' App code",
    "ja": "他のユーザーのアプリコードをアクティベートする",
    "zh": "激活其他用戶的應用碼",
    "zh_cn": "激活其他用户的应用码"
  },
  "stardust_task_content3": {
    "en": "Invite friends to Yulimeta APP and share your App code .Once they activate the code,you will get one VALID invite.",
    "ja": "Yulimetaアプリに友達を招待して、アプリのコードを共有してください。あなたのコードがアクティベートされると有効になります。",
    "zh": "邀請朋友加入 Yulimeta 應用 並分享您的應用碼。一旦他們激活代碼，視為您完成一次有效邀請。",
    "zh_cn": "邀请朋友加入 Yulimeta 应用 并分享您的应用码。一旦他们激活代码，视为您完成一次有效邀请。"
  },
  "stardust_task_content4": {
    "en": "Seek and collect stardust on Yuli Map, and daily collection limit is 450.",
    "ja": "マップでスターダストを探して収集します。1日の収集制限は450です。",
    "zh": "在地圖中尋找和收集星塵，每日上限為450。",
    "zh_cn": "在地图中寻找和收集星尘，每日上限为450。"
  },
  "stardust_today": {
    "en": "Today",
    "ja": "今日",
    "zh": "今日獲得",
    "zh_cn": "今日获得"
  },
  "stardust_total": {
    "en": "Total",
    "ja": "合計",
    "zh": "總計",
    "zh_cn": "总计"
  },
  "task_beginner_title": {
    "en": "Beginner Tasks",
    "ja": "ビギナータスク",
    "zh": "新手任務",
    "zh_cn": "新手任务"
  },
  "task_beginner_toast1": {
    "en": "1. Connect a Wallet account\nClick Wallet button to check in-gamewallet, connect it with your onchainwallet account.",
    "ja": "1.ウォレットアカウントを接続する\n「ウォレット」ボタンをクリックしてゲーム内ウォレットを確認し、オンチェーンウォレットアカウントに接続します。",
    "zh": "1. 連接錢包賬戶\n點擊錢包按鈕查看遊戲內錢包，將其與您的鏈上錢包賬戶關聯。",
    "zh_cn": "1. 连接钱包账户\n点击钱包按钮查看游戏内钱包，将其与您的链上钱包账户关联。"
  },
  "task_beginner_toast2": {
    "en": "2. Seek Terra and collect Stardust\nClick Seek Terra button to open Yulimap,then seek for Stardust and collect it.",
    "ja": "2. スターダストを集める\n「Terraを探す」ボタンをクリックしてマップを開き、スターダストを探して集めます。",
    "zh": "2.收集星塵\n點擊「凈化地脈」按鈕打開地圖，然後尋找星塵並收集它。",
    "zh_cn": "2.收集星尘\n点击“净化地脉”按钮打开地图，然后寻找星尘并收集它。"
  },
  "task_beginner_toast3": {
    "en": "3. Seek Terra and purify a Terra\nClick Seek Terra button to open Yulimap,then seek for Terras and purifyone Terra.",
    "ja": "3.Terraを浄化する\n「Terraを探す」ボタンをクリックしてマップを開き、Terra を探して 1 つの Terra を浄化します。",
    "zh": "3. 凈化地脈\n點擊「凈化地脈」按鈕打開地圖，然後尋找Terra並凈化一個Terra。",
    "zh_cn": "3. 净化地脉\n点击“净化地脉”按钮打开地图，然后寻找Terra并净化一个Terra。"
  },
  "task_claim_button": {
    "en": "Claim",
    "ja": "受け取る",
    "zh": "領取",
    "zh_cn": "领取"
  },
  "task_claimed_button": {
    "en": "Claimed",
    "ja": "受け取り済",
    "zh": "已領取",
    "zh_cn": "已领取"
  },
  "task_go_now_button": {
    "en": "Go now",
    "ja": "Go now",
    "zh": "立即开始",
    "zh_cn": "立即开始"
  },
  "task_locked_button": {
    "en": "Locked",
    "ja": "Locked",
    "zh": "未解鎖",
    "zh_cn": "未解锁"
  },
  "task_reward": {
    "en": "Reward",
    "ja": "報酬",
    "zh": "獎勵",
    "zh_cn": "奖励"
  },
  "version": 434
}